// This file is auto-generated by @hey-api/openapi-ts

import type { Client, ClientMeta, Options as Options2, RequestResult, TDataShape } from './client';
import { client } from './client.gen';
import type { AdoptionsListData, AdoptionsListErrors, AdoptionsListResponses, AgentCredentialsArchiveData, AgentCredentialsArchiveErrors, AgentCredentialsArchiveResponses, AgentCredentialsGetData, AgentCredentialsGetErrors, AgentCredentialsGetResponses, AgentCredentialsListData, AgentCredentialsListErrors, AgentCredentialsListResponses, AgentCredentialsSetData, AgentCredentialsSetErrors, AgentCredentialsSetResponses, AgentCredentialsVerifyData, AgentCredentialsVerifyErrors, AgentCredentialsVerifyResponses, AgentMessagesListData, AgentMessagesListErrors, AgentMessagesListResponses, AgentMessagesNewData, AgentMessagesNewErrors, AgentMessagesNewResponses, AgentModelsListData, AgentModelsListErrors, AgentModelsListResponses, AgentProfileEditData, AgentProfileEditErrors, AgentProfileEditResponses, AgentProfileGetData, AgentProfileGetErrors, AgentProfileGetResponses, AgentProvidersListData, AgentProvidersListErrors, AgentProvidersListResponses, AgentSessionsAcceptData, AgentSessionsAcceptErrors, AgentSessionsAcceptResponses, AgentSessionsCancelData, AgentSessionsCancelErrors, AgentSessionsCancelResponses, AgentSessionsGetData, AgentSessionsGetErrors, AgentSessionsGetResponses, AgentSessionsListData, AgentSessionsListErrors, AgentSessionsListResponses, AgentSessionsNewData, AgentSessionsNewErrors, AgentSessionsNewResponses, AgentSessionsPauseData, AgentSessionsPauseErrors, AgentSessionsPauseResponses, AgentSessionsResumeData, AgentSessionsResumeErrors, AgentSessionsResumeResponses, AgentSessionsRevertData, AgentSessionsRevertErrors, AgentSessionsRevertResponses, AliasesGetData, AliasesGetErrors, AliasesGetResponses, AliasesListData, AliasesListErrors, AliasesListResponses, AliasesSetData, AliasesSetErrors, AliasesSetResponses, AnnotationsNewData, AnnotationsNewErrors, AnnotationsNewResponses, ApprovalsApproveData, ApprovalsApproveErrors, ApprovalsApproveResponses, ApprovalsDenyData, ApprovalsDenyErrors, ApprovalsDenyResponses, ApprovalsGetData, ApprovalsGetErrors, ApprovalsGetResponses, ApprovalsListData, ApprovalsListErrors, ApprovalsListResponses, ArtifactsEvictData, ArtifactsEvictErrors, ArtifactsEvictResponses, ArtifactsGetData, ArtifactsGetErrors, ArtifactsGetResponses, AudioGetData, AudioGetErrors, AudioGetResponses, AudioSignData, AudioSignErrors, AudioSignResponses, AuditListData, AuditListErrors, AuditListResponses, AuthAcceptData, AuthAcceptErrors, AuthAcceptResponses, AuthGetData, AuthGetErrors, AuthGetResponses, AuthLoginData, AuthLoginErrors, AuthLoginResponses, AuthLogoutData, AuthLogoutErrors, AuthLogoutResponses, AuthSetupData, AuthSetupErrors, AuthSetupResponses, AuxiliariesGetData, AuxiliariesGetErrors, AuxiliariesGetResponses, AuxiliariesListData, AuxiliariesListErrors, AuxiliariesListResponses, BackupsGetData, BackupsGetErrors, BackupsGetResponses, BackupsListData, BackupsListErrors, BackupsListResponses, BackupsNewData, BackupsNewErrors, BackupsNewResponses, BackupsVerifyData, BackupsVerifyErrors, BackupsVerifyResponses, BaseModelsGetData, BaseModelsGetErrors, BaseModelsGetResponses, BaseModelsListData, BaseModelsListErrors, BaseModelsListResponses, BatchesFreezeData, BatchesFreezeErrors, BatchesFreezeResponses, BatchesGetData, BatchesGetErrors, BatchesGetResponses, BatchesListData, BatchesListErrors, BatchesListResponses, BatchesNewData, BatchesNewErrors, BatchesNewResponses, BatchItemsAcceptData, BatchItemsAcceptErrors, BatchItemsAcceptResponses, BatchItemsGetData, BatchItemsGetErrors, BatchItemsGetResponses, BatchItemsListData, BatchItemsListErrors, BatchItemsListResponses, BoostEditData, BoostEditErrors, BoostEditResponses, BranchesAcceptData, BranchesAcceptErrors, BranchesAcceptResponses, BranchesCompareData, BranchesCompareErrors, BranchesCompareResponses, BranchesGetData, BranchesGetErrors, BranchesGetResponses, BranchesListData, BranchesListErrors, BranchesListResponses, BranchesRevertData, BranchesRevertErrors, BranchesRevertResponses, BundlesAdoptData, BundlesAdoptErrors, BundlesAdoptResponses, CheckpointsAverageData, CheckpointsAverageErrors, CheckpointsAverageResponses, CheckpointsGetData, CheckpointsGetErrors, CheckpointsGetResponses, CheckpointsListData, CheckpointsListErrors, CheckpointsListResponses, CollectionsGetData, CollectionsGetErrors, CollectionsGetResponses, CollectionsListData, CollectionsListErrors, CollectionsListResponses, ComputeEditData, ComputeEditErrors, ComputeEditResponses, ComputeGetData, ComputeGetErrors, ComputeGetResponses, ComputeListData, ComputeListErrors, ComputeListResponses, CredentialsListData, CredentialsListErrors, CredentialsListResponses, CredentialsNewData, CredentialsNewErrors, CredentialsNewResponses, CredentialsRevokeData, CredentialsRevokeErrors, CredentialsRevokeResponses, DatasetsEvictData, DatasetsEvictErrors, DatasetsEvictResponses, DatasetsExportData, DatasetsExportErrors, DatasetsExportResponses, DatasetsFreezeData, DatasetsFreezeErrors, DatasetsFreezeResponses, DatasetsGetData, DatasetsGetErrors, DatasetsGetResponses, DatasetsListData, DatasetsListErrors, DatasetsListResponses, DatasetsMaterializeData, DatasetsMaterializeErrors, DatasetsMaterializeResponses, DatasetsPreviewData, DatasetsPreviewErrors, DatasetsPreviewResponses, DefaultsGetData, DefaultsGetErrors, DefaultsGetResponses, DeliveryGetData, DeliveryGetErrors, DeliveryGetResponses, DeploymentsGetData, DeploymentsGetErrors, DeploymentsGetResponses, DeploymentsListData, DeploymentsListErrors, DeploymentsListResponses, DeploymentsNewData, DeploymentsNewErrors, DeploymentsNewResponses, DeploymentsPromoteData, DeploymentsPromoteErrors, DeploymentsPromoteResponses, DeploymentsRollbackData, DeploymentsRollbackErrors, DeploymentsRollbackResponses, DeploymentTargetsArchiveData, DeploymentTargetsArchiveErrors, DeploymentTargetsArchiveResponses, DeploymentTargetsEditData, DeploymentTargetsEditErrors, DeploymentTargetsEditResponses, DeploymentTargetsGetData, DeploymentTargetsGetErrors, DeploymentTargetsGetResponses, DeploymentTargetsListData, DeploymentTargetsListErrors, DeploymentTargetsListResponses, DeploymentTargetsNewData, DeploymentTargetsNewErrors, DeploymentTargetsNewResponses, DraftsAcceptData, DraftsAcceptErrors, DraftsAcceptResponses, DraftsGetData, DraftsGetErrors, DraftsGetResponses, DraftsListData, DraftsListErrors, DraftsListResponses, DraftsRevertData, DraftsRevertErrors, DraftsRevertResponses, EgressHostsListData, EgressHostsListErrors, EgressHostsListResponses, EvalsGateData, EvalsGateErrors, EvalsGateResponses, EvalsGetData, EvalsGetErrors, EvalsGetResponses, EvalsListData, EvalsListErrors, EvalsListResponses, EvalsNewData, EvalsNewErrors, EvalsNewResponses, EventsListData, EventsListErrors, EventsListResponses, ExperimentsGetData, ExperimentsGetErrors, ExperimentsGetResponses, ExperimentsListData, ExperimentsListErrors, ExperimentsListResponses, ExperimentsNewData, ExperimentsNewErrors, ExperimentsNewResponses, ExportsGetData, ExportsGetErrors, ExportsGetResponses, ExportsListData, ExportsListErrors, ExportsListResponses, GatesEditData, GatesEditErrors, GatesEditResponses, GatesGetData, GatesGetErrors, GatesGetResponses, GoldenSetsAlignData, GoldenSetsAlignErrors, GoldenSetsAlignResponses, GoldenSetsFreezeData, GoldenSetsFreezeErrors, GoldenSetsFreezeResponses, GoldenSetsGetData, GoldenSetsGetErrors, GoldenSetsGetResponses, GoldenSetsListData, GoldenSetsListErrors, GoldenSetsListResponses, GuidelinesGetData, GuidelinesGetErrors, GuidelinesGetResponses, HelpGetData, HelpGetErrors, HelpGetResponses, HelpSearchData, HelpSearchErrors, HelpSearchResponses, HostCredentialsClaimData, HostCredentialsClaimErrors, HostCredentialsClaimResponses, HostCredentialsReportData, HostCredentialsReportErrors, HostCredentialsReportResponses, HostSessionsAskData, HostSessionsAskErrors, HostSessionsAskResponses, HostSessionsClaimData, HostSessionsClaimErrors, HostSessionsClaimResponses, HostSessionsDecisionData, HostSessionsDecisionErrors, HostSessionsDecisionResponses, HostSessionsReleaseData, HostSessionsReleaseErrors, HostSessionsReleaseResponses, HostSessionsReportData, HostSessionsReportErrors, HostSessionsReportResponses, InvitationsListData, InvitationsListErrors, InvitationsListResponses, InvitationsNewData, InvitationsNewErrors, InvitationsNewResponses, JobLogsListData, JobLogsListErrors, JobLogsListResponses, JobsCancelData, JobsCancelErrors, JobsCancelResponses, JobsEditData, JobsEditErrors, JobsEditResponses, JobsGetData, JobsGetErrors, JobsGetResponses, JobsListData, JobsListErrors, JobsListResponses, JobsPauseData, JobsPauseErrors, JobsPauseResponses, JobsResumeData, JobsResumeErrors, JobsResumeResponses, JobsWaitData, JobsWaitErrors, JobsWaitResponses, LangpacksEditData, LangpacksEditErrors, LangpacksEditResponses, LangpacksGetData, LangpacksGetErrors, LangpacksGetResponses, LangpacksListData, LangpacksListErrors, LangpacksListResponses, MeGetData, MeGetErrors, MeGetResponses, MetricsGetData, MetricsGetErrors, MetricsGetResponses, MixesEditData, MixesEditErrors, MixesEditResponses, MixesGetData, MixesGetErrors, MixesGetResponses, MixesListData, MixesListErrors, MixesListResponses, MixesNewData, MixesNewErrors, MixesNewResponses, MixesPreviewData, MixesPreviewErrors, MixesPreviewResponses, ModelFamiliesGetData, ModelFamiliesGetErrors, ModelFamiliesGetResponses, ModelFamiliesListData, ModelFamiliesListErrors, ModelFamiliesListResponses, ModelsBenchmarkData, ModelsBenchmarkErrors, ModelsBenchmarkResponses, ModelsExportData, ModelsExportErrors, ModelsExportResponses, ModelsGetData, ModelsGetErrors, ModelsGetResponses, ModelsListData, ModelsListErrors, ModelsListResponses, ModelsParityData, ModelsParityErrors, ModelsParityResponses, ModelsRegisterData, ModelsRegisterErrors, ModelsRegisterResponses, MountsGetData, MountsGetErrors, MountsGetResponses, MountsListData, MountsListErrors, MountsListResponses, MountsNewData, MountsNewErrors, MountsNewResponses, MountsScanData, MountsScanErrors, MountsScanResponses, MountsVerifyData, MountsVerifyErrors, MountsVerifyResponses, NormalizersGetData, NormalizersGetErrors, NormalizersGetResponses, NormalizersListData, NormalizersListErrors, NormalizersListResponses, NotificationRulesEditData, NotificationRulesEditErrors, NotificationRulesEditResponses, NotificationRulesListData, NotificationRulesListErrors, NotificationRulesListResponses, NotificationSettingsEditData, NotificationSettingsEditErrors, NotificationSettingsEditResponses, NotificationSettingsGetData, NotificationSettingsGetErrors, NotificationSettingsGetResponses, PeaksGetData, PeaksGetErrors, PeaksGetResponses, PipelineRunsCancelData, PipelineRunsCancelErrors, PipelineRunsCancelResponses, PipelineRunsGetData, PipelineRunsGetErrors, PipelineRunsGetResponses, PipelineRunsListData, PipelineRunsListErrors, PipelineRunsListResponses, PipelineRunsRetryData, PipelineRunsRetryErrors, PipelineRunsRetryResponses, PipelineRunsWaitData, PipelineRunsWaitErrors, PipelineRunsWaitResponses, PipelinesListData, PipelinesListErrors, PipelinesListResponses, PipelinesRunData, PipelinesRunErrors, PipelinesRunResponses, PlaybooksGetData, PlaybooksGetErrors, PlaybooksGetResponses, PlaybooksListData, PlaybooksListErrors, PlaybooksListResponses, PlaybooksRunData, PlaybooksRunErrors, PlaybooksRunResponses, PoliciesEditData, PoliciesEditErrors, PoliciesEditResponses, PoliciesGetData, PoliciesGetErrors, PoliciesGetResponses, ProjectsAdoptData, ProjectsAdoptErrors, ProjectsAdoptResponses, ProjectsArchiveData, ProjectsArchiveErrors, ProjectsArchiveResponses, ProjectsEditData, ProjectsEditErrors, ProjectsEditResponses, ProjectsExportData, ProjectsExportErrors, ProjectsExportResponses, ProjectsGetData, ProjectsGetErrors, ProjectsGetResponses, ProjectsListData, ProjectsListErrors, ProjectsListResponses, ProjectsNewData, ProjectsNewErrors, ProjectsNewResponses, ProjectsNoteData, ProjectsNoteErrors, ProjectsNoteResponses, ProjectsSearchData, ProjectsSearchErrors, ProjectsSearchResponses, ProjectsSyncData, ProjectsSyncErrors, ProjectsSyncResponses, PromotionsGetData, PromotionsGetErrors, PromotionsGetResponses, PromotionsListData, PromotionsListErrors, PromotionsListResponses, PromotionsVerifyData, PromotionsVerifyErrors, PromotionsVerifyResponses, QueueEntriesListData, QueueEntriesListErrors, QueueEntriesListResponses, RecipesEditData, RecipesEditErrors, RecipesEditResponses, RecipesGetData, RecipesGetErrors, RecipesGetResponses, RecipesListData, RecipesListErrors, RecipesListResponses, RecipesNewData, RecipesNewErrors, RecipesNewResponses, RegistryLineageData, RegistryLineageErrors, RegistryLineageResponses, RegistrySearchData, RegistrySearchErrors, RegistrySearchResponses, RunsCalibrateData, RunsCalibrateErrors, RunsCalibrateResponses, RunsGetData, RunsGetErrors, RunsGetResponses, RunsListData, RunsListErrors, RunsListResponses, RunsNewData, RunsNewErrors, RunsNewResponses, RunsResumeData, RunsResumeErrors, RunsResumeResponses, RunsStageData, RunsStageErrors, RunsStageResponses, RuntimesGetData, RuntimesGetErrors, RuntimesGetResponses, RuntimesListData, RuntimesListErrors, RuntimesListResponses, SecretsListData, SecretsListErrors, SecretsListResponses, SecretsNewData, SecretsNewErrors, SecretsNewResponses, ShadowReplaysGetData, ShadowReplaysGetErrors, ShadowReplaysGetResponses, ShadowReplaysListData, ShadowReplaysListErrors, ShadowReplaysListResponses, ShadowReplaysNewData, ShadowReplaysNewErrors, ShadowReplaysNewResponses, SourcesArchiveData, SourcesArchiveErrors, SourcesArchiveResponses, SourcesEditData, SourcesEditErrors, SourcesEditResponses, SourcesGetData, SourcesGetErrors, SourcesGetResponses, SourcesListData, SourcesListErrors, SourcesListResponses, SourcesNewData, SourcesNewErrors, SourcesNewResponses, SpectrogramGetData, SpectrogramGetErrors, SpectrogramGetResponses, StepKindsGetData, StepKindsGetErrors, StepKindsGetResponses, StepKindsListData, StepKindsListErrors, StepKindsListResponses, StorageGetData, StorageGetErrors, StorageGetResponses, StreamConnectData, StreamConnectErrors, StreamConnectResponses, SweepsRunData, SweepsRunErrors, SweepsRunResponses, TelegramBotSetData, TelegramBotSetErrors, TelegramBotSetResponses, TelegramBotVerifyData, TelegramBotVerifyErrors, TelegramBotVerifyResponses, TemplatesGetData, TemplatesGetErrors, TemplatesGetResponses, TemplatesListData, TemplatesListErrors, TemplatesListResponses, TextsGetData, TextsGetErrors, TextsGetResponses, TotpConfirmData, TotpConfirmErrors, TotpConfirmResponses, TotpDisableData, TotpDisableErrors, TotpDisableResponses, TotpEnrollData, TotpEnrollErrors, TotpEnrollResponses, TracksGetData, TracksGetErrors, TracksGetResponses, TranscriptionsNewData, TranscriptionsNewErrors, TranscriptionsNewResponses, TriageAcceptData, TriageAcceptErrors, TriageAcceptResponses, TriageCorrectData, TriageCorrectErrors, TriageCorrectResponses, TriageListData, TriageListErrors, TriageListResponses, TriageRejectData, TriageRejectErrors, TriageRejectResponses, UtterancesGetData, UtterancesGetErrors, UtterancesGetResponses, UtterancesListData, UtterancesListErrors, UtterancesListResponses, UtterancesSearchData, UtterancesSearchErrors, UtterancesSearchResponses, VersionsArchiveData, VersionsArchiveErrors, VersionsArchiveResponses, ViewsGetData, ViewsGetErrors, ViewsGetResponses, ViewsListData, ViewsListErrors, ViewsListResponses, ViewsSetData, ViewsSetErrors, ViewsSetResponses, WordsGetData, WordsGetErrors, WordsGetResponses, WorkerArtifactsSetData, WorkerArtifactsSetErrors, WorkerArtifactsSetResponses, WorkerLeasesClaimData, WorkerLeasesClaimErrors, WorkerLeasesClaimResponses, WorkerLeasesReleaseData, WorkerLeasesReleaseErrors, WorkerLeasesReleaseResponses, WorkerLeasesReportData, WorkerLeasesReportErrors, WorkerLeasesReportResponses, WorkerLiveConnectData, WorkerLiveConnectErrors, WorkerLiveConnectResponses, WorkerLogsNewData, WorkerLogsNewErrors, WorkerLogsNewResponses, WorkerMetricsNewData, WorkerMetricsNewErrors, WorkerMetricsNewResponses, WorkerOutputsNewData, WorkerOutputsNewErrors, WorkerOutputsNewResponses, WorkerRegistrationsNewData, WorkerRegistrationsNewErrors, WorkerRegistrationsNewResponses, WorkspacesGetData, WorkspacesGetErrors, WorkspacesGetResponses, WorkspacesListData, WorkspacesListErrors, WorkspacesListResponses, WorkspacesSetData, WorkspacesSetErrors, WorkspacesSetResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean, TResponse = unknown> = Options2<TData, ThrowOnError, TResponse> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: keyof ClientMeta extends never ? Record<string, unknown> : ClientMeta;
};

/**
 * List projects
 */
export const projectsList = <ThrowOnError extends boolean = false>(options?: Options<ProjectsListData, ThrowOnError>): RequestResult<ProjectsListResponses, ProjectsListErrors, ThrowOnError> => (options?.client ?? client).get<ProjectsListResponses, ProjectsListErrors, ThrowOnError>({ url: '/projects', ...options });

/**
 * Create a project from the wizard's choices and bootstrap its repository (202 with the bootstrap job)
 */
export const projectsNew = <ThrowOnError extends boolean = false>(options: Options<ProjectsNewData, ThrowOnError>): RequestResult<ProjectsNewResponses, ProjectsNewErrors, ThrowOnError> => (options.client ?? client).post<ProjectsNewResponses, ProjectsNewErrors, ThrowOnError>({
    url: '/projects',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get a project
 */
export const projectsGet = <ThrowOnError extends boolean = false>(options: Options<ProjectsGetData, ThrowOnError>): RequestResult<ProjectsGetResponses, ProjectsGetErrors, ThrowOnError> => (options.client ?? client).get<ProjectsGetResponses, ProjectsGetErrors, ThrowOnError>({ url: '/projects/{p}', ...options });

/**
 * Change a project's name, description, locales, domain, base model or budgets
 */
export const projectsEdit = <ThrowOnError extends boolean = false>(options: Options<ProjectsEditData, ThrowOnError>): RequestResult<ProjectsEditResponses, ProjectsEditErrors, ThrowOnError> => (options.client ?? client).patch<ProjectsEditResponses, ProjectsEditErrors, ThrowOnError>({
    url: '/projects/{p}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Archive a project (soft; reversible)
 */
export const projectsArchive = <ThrowOnError extends boolean = false>(options: Options<ProjectsArchiveData, ThrowOnError>): RequestResult<ProjectsArchiveResponses, ProjectsArchiveErrors, ThrowOnError> => (options.client ?? client).post<ProjectsArchiveResponses, ProjectsArchiveErrors, ThrowOnError>({ url: '/projects/{p}:archive', ...options });

/**
 * The current actor
 */
export const meGet = <ThrowOnError extends boolean = false>(options?: Options<MeGetData, ThrowOnError>): RequestResult<MeGetResponses, MeGetErrors, ThrowOnError> => (options?.client ?? client).get<MeGetResponses, MeGetErrors, ThrowOnError>({ url: '/me', ...options });

/**
 * The user's saved workspaces in a project (names and revisions, no layouts)
 */
export const workspacesList = <ThrowOnError extends boolean = false>(options: Options<WorkspacesListData, ThrowOnError>): RequestResult<WorkspacesListResponses, WorkspacesListErrors, ThrowOnError> => (options.client ?? client).get<WorkspacesListResponses, WorkspacesListErrors, ThrowOnError>({ url: '/me/projects/{p}/workspaces', ...options });

/**
 * Get a saved workspace
 */
export const workspacesGet = <ThrowOnError extends boolean = false>(options: Options<WorkspacesGetData, ThrowOnError>): RequestResult<WorkspacesGetResponses, WorkspacesGetErrors, ThrowOnError> => (options.client ?? client).get<WorkspacesGetResponses, WorkspacesGetErrors, ThrowOnError>({ url: '/me/projects/{p}/workspaces/{name}', ...options });

/**
 * Save a workspace layout (If-Match; omit it only to create)
 */
export const workspacesSet = <ThrowOnError extends boolean = false>(options: Options<WorkspacesSetData, ThrowOnError>): RequestResult<WorkspacesSetResponses, WorkspacesSetErrors, ThrowOnError> => (options.client ?? client).put<WorkspacesSetResponses, WorkspacesSetErrors, ThrowOnError>({
    url: '/me/projects/{p}/workspaces/{name}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Events after a sequence number; with Accept text/event-stream, the live stream
 */
export const eventsList = <ThrowOnError extends boolean = false>(options?: Options<EventsListData, ThrowOnError>): RequestResult<EventsListResponses, EventsListErrors, ThrowOnError> => (options?.client ?? client).get<EventsListResponses, EventsListErrors, ThrowOnError>({ url: '/events', ...options });

/**
 * Search help articles by text or by context (panel, step kind, error type, field)
 */
export const helpSearch = <ThrowOnError extends boolean = false>(options?: Options<HelpSearchData, ThrowOnError>): RequestResult<HelpSearchResponses, HelpSearchErrors, ThrowOnError> => (options?.client ?? client).get<HelpSearchResponses, HelpSearchErrors, ThrowOnError>({ url: '/help', ...options });

/**
 * Get a help article (markdown)
 */
export const helpGet = <ThrowOnError extends boolean = false>(options: Options<HelpGetData, ThrowOnError>): RequestResult<HelpGetResponses, HelpGetErrors, ThrowOnError> => (options.client ?? client).get<HelpGetResponses, HelpGetErrors, ThrowOnError>({ url: '/help/{id}', ...options });

/**
 * Search registry versions of every kind by text and qualifiers (kind:, tag:, locale:, state:)
 */
export const registrySearch = <ThrowOnError extends boolean = false>(options?: Options<RegistrySearchData, ThrowOnError>): RequestResult<RegistrySearchResponses, RegistrySearchErrors, ThrowOnError> => (options?.client ?? client).get<RegistrySearchResponses, RegistrySearchErrors, ThrowOnError>({ url: '/registry', ...options });

/**
 * Sign-in state — whether first start is pending and who is signed in
 */
export const authGet = <ThrowOnError extends boolean = false>(options?: Options<AuthGetData, ThrowOnError>): RequestResult<AuthGetResponses, AuthGetErrors, ThrowOnError> => (options?.client ?? client).get<AuthGetResponses, AuthGetErrors, ThrowOnError>({ url: '/auth', ...options });

/**
 * First start — set the admin password once and sign in; refused (409) once a password is set
 */
export const authSetup = <ThrowOnError extends boolean = false>(options: Options<AuthSetupData, ThrowOnError>): RequestResult<AuthSetupResponses, AuthSetupErrors, ThrowOnError> => (options.client ?? client).post<AuthSetupResponses, AuthSetupErrors, ThrowOnError>({
    url: '/auth:setup',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Sign in with username, password and, when enabled, a TOTP code; rate-limited per address and username
 */
export const authLogin = <ThrowOnError extends boolean = false>(options: Options<AuthLoginData, ThrowOnError>): RequestResult<AuthLoginResponses, AuthLoginErrors, ThrowOnError> => (options.client ?? client).post<AuthLoginResponses, AuthLoginErrors, ThrowOnError>({
    url: '/auth:login',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Sign out — revoke this browser's session and clear its cookie
 */
export const authLogout = <ThrowOnError extends boolean = false>(options?: Options<AuthLogoutData, ThrowOnError>): RequestResult<AuthLogoutResponses, AuthLogoutErrors, ThrowOnError> => (options?.client ?? client).post<AuthLogoutResponses, AuthLogoutErrors, ThrowOnError>({ url: '/auth:logout', ...options });

/**
 * Start TOTP enrollment for the signed-in user — a new secret, active once confirmed
 */
export const totpEnroll = <ThrowOnError extends boolean = false>(options?: Options<TotpEnrollData, ThrowOnError>): RequestResult<TotpEnrollResponses, TotpEnrollErrors, ThrowOnError> => (options?.client ?? client).post<TotpEnrollResponses, TotpEnrollErrors, ThrowOnError>({ url: '/auth/totp:enroll', ...options });

/**
 * Confirm TOTP enrollment with a current code; sign-in asks for a code from then on
 */
export const totpConfirm = <ThrowOnError extends boolean = false>(options: Options<TotpConfirmData, ThrowOnError>): RequestResult<TotpConfirmResponses, TotpConfirmErrors, ThrowOnError> => (options.client ?? client).post<TotpConfirmResponses, TotpConfirmErrors, ThrowOnError>({
    url: '/auth/totp:confirm',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Turn TOTP off for the signed-in user with a current code
 */
export const totpDisable = <ThrowOnError extends boolean = false>(options: Options<TotpDisableData, ThrowOnError>): RequestResult<TotpDisableResponses, TotpDisableErrors, ThrowOnError> => (options.client ?? client).post<TotpDisableResponses, TotpDisableErrors, ThrowOnError>({
    url: '/auth/totp:disable',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List credentials (sessions, API keys, agent tokens) without their secrets
 */
export const credentialsList = <ThrowOnError extends boolean = false>(options?: Options<CredentialsListData, ThrowOnError>): RequestResult<CredentialsListResponses, CredentialsListErrors, ThrowOnError> => (options?.client ?? client).get<CredentialsListResponses, CredentialsListErrors, ThrowOnError>({ url: '/credentials', ...options });

/**
 * Create a personal API key (cdk_) scoped to one project or to registry read
 */
export const credentialsNew = <ThrowOnError extends boolean = false>(options: Options<CredentialsNewData, ThrowOnError>): RequestResult<CredentialsNewResponses, CredentialsNewErrors, ThrowOnError> => (options.client ?? client).post<CredentialsNewResponses, CredentialsNewErrors, ThrowOnError>({
    url: '/credentials',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Revoke a credential; requests carrying it are refused from now on (irreversible)
 */
export const credentialsRevoke = <ThrowOnError extends boolean = false>(options: Options<CredentialsRevokeData, ThrowOnError>): RequestResult<CredentialsRevokeResponses, CredentialsRevokeErrors, ThrowOnError> => (options.client ?? client).post<CredentialsRevokeResponses, CredentialsRevokeErrors, ThrowOnError>({ url: '/credentials/{id}:revoke', ...options });

/**
 * List registry collections (named series of immutable versions), optionally of one kind or tag
 */
export const collectionsList = <ThrowOnError extends boolean = false>(options?: Options<CollectionsListData, ThrowOnError>): RequestResult<CollectionsListResponses, CollectionsListErrors, ThrowOnError> => (options?.client ?? client).get<CollectionsListResponses, CollectionsListErrors, ThrowOnError>({ url: '/registry/collections', ...options });

/**
 * Get a registry collection with its versions, newest first
 */
export const collectionsGet = <ThrowOnError extends boolean = false>(options: Options<CollectionsGetData, ThrowOnError>): RequestResult<CollectionsGetResponses, CollectionsGetErrors, ThrowOnError> => (options.client ?? client).get<CollectionsGetResponses, CollectionsGetErrors, ThrowOnError>({ url: '/registry/collections/{id}', ...options });

/**
 * List base model versions (Hugging Face repository at a pinned revision, licence, model family)
 */
export const baseModelsList = <ThrowOnError extends boolean = false>(options?: Options<BaseModelsListData, ThrowOnError>): RequestResult<BaseModelsListResponses, BaseModelsListErrors, ThrowOnError> => (options?.client ?? client).get<BaseModelsListResponses, BaseModelsListErrors, ThrowOnError>({ url: '/registry/base-models', ...options });

/**
 * Get a base model version with the projects that use it
 */
export const baseModelsGet = <ThrowOnError extends boolean = false>(options: Options<BaseModelsGetData, ThrowOnError>): RequestResult<BaseModelsGetResponses, BaseModelsGetErrors, ThrowOnError> => (options.client ?? client).get<BaseModelsGetResponses, BaseModelsGetErrors, ThrowOnError>({ url: '/registry/base-models/{id}', ...options });

/**
 * List dataset versions (immutable, fingerprinted selections with splits and statistics)
 */
export const datasetsList = <ThrowOnError extends boolean = false>(options?: Options<DatasetsListData, ThrowOnError>): RequestResult<DatasetsListResponses, DatasetsListErrors, ThrowOnError> => (options?.client ?? client).get<DatasetsListResponses, DatasetsListErrors, ThrowOnError>({ url: '/registry/datasets', ...options });

/**
 * Get a dataset version with its splits, statistics and the projects that use it
 */
export const datasetsGet = <ThrowOnError extends boolean = false>(options: Options<DatasetsGetData, ThrowOnError>): RequestResult<DatasetsGetResponses, DatasetsGetErrors, ThrowOnError> => (options.client ?? client).get<DatasetsGetResponses, DatasetsGetErrors, ThrowOnError>({ url: '/registry/datasets/{id}', ...options });

/**
 * List template versions (instruction templates, permission presets, skills, pipeline templates, agent config)
 */
export const templatesList = <ThrowOnError extends boolean = false>(options?: Options<TemplatesListData, ThrowOnError>): RequestResult<TemplatesListResponses, TemplatesListErrors, ThrowOnError> => (options?.client ?? client).get<TemplatesListResponses, TemplatesListErrors, ThrowOnError>({ url: '/registry/templates', ...options });

/**
 * Get a template version with its files (paths and hashes) and the projects that use it
 */
export const templatesGet = <ThrowOnError extends boolean = false>(options: Options<TemplatesGetData, ThrowOnError>): RequestResult<TemplatesGetResponses, TemplatesGetErrors, ThrowOnError> => (options.client ?? client).get<TemplatesGetResponses, TemplatesGetErrors, ThrowOnError>({ url: '/registry/templates/{id}', ...options });

/**
 * Adopt a registry version into the project by reference
 */
export const projectsAdopt = <ThrowOnError extends boolean = false>(options: Options<ProjectsAdoptData, ThrowOnError>): RequestResult<ProjectsAdoptResponses, ProjectsAdoptErrors, ThrowOnError> => (options.client ?? client).post<ProjectsAdoptResponses, ProjectsAdoptErrors, ThrowOnError>({
    url: '/projects/{p}:adopt',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Registry versions the project adopted, with the aliases pointing at each
 */
export const adoptionsList = <ThrowOnError extends boolean = false>(options: Options<AdoptionsListData, ThrowOnError>): RequestResult<AdoptionsListResponses, AdoptionsListErrors, ThrowOnError> => (options.client ?? client).get<AdoptionsListResponses, AdoptionsListErrors, ThrowOnError>({ url: '/projects/{p}/adoptions', ...options });

/**
 * The project's aliases (train-current, baseline, production, …) and the versions they point at
 */
export const aliasesList = <ThrowOnError extends boolean = false>(options: Options<AliasesListData, ThrowOnError>): RequestResult<AliasesListResponses, AliasesListErrors, ThrowOnError> => (options.client ?? client).get<AliasesListResponses, AliasesListErrors, ThrowOnError>({ url: '/projects/{p}/aliases', ...options });

/**
 * Get one project alias and the version it points at
 */
export const aliasesGet = <ThrowOnError extends boolean = false>(options: Options<AliasesGetData, ThrowOnError>): RequestResult<AliasesGetResponses, AliasesGetErrors, ThrowOnError> => (options.client ?? client).get<AliasesGetResponses, AliasesGetErrors, ThrowOnError>({ url: '/projects/{p}/aliases/{name}', ...options });

/**
 * Point a project alias at an adopted registry version (baseline is gated, production moves only by promotion)
 */
export const aliasesSet = <ThrowOnError extends boolean = false>(options: Options<AliasesSetData, ThrowOnError>): RequestResult<AliasesSetResponses, AliasesSetErrors, ThrowOnError> => (options.client ?? client).put<AliasesSetResponses, AliasesSetErrors, ThrowOnError>({
    url: '/projects/{p}/aliases/{name}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Hosts and their cards (memory cap per card, allowed job kinds) with health
 */
export const computeList = <ThrowOnError extends boolean = false>(options?: Options<ComputeListData, ThrowOnError>): RequestResult<ComputeListResponses, ComputeListErrors, ThrowOnError> => (options?.client ?? client).get<ComputeListResponses, ComputeListErrors, ThrowOnError>({ url: '/compute', ...options });

/**
 * Get a host and its cards
 */
export const computeGet = <ThrowOnError extends boolean = false>(options: Options<ComputeGetData, ThrowOnError>): RequestResult<ComputeGetResponses, ComputeGetErrors, ThrowOnError> => (options.client ?? client).get<ComputeGetResponses, ComputeGetErrors, ThrowOnError>({ url: '/compute/{id}', ...options });

/**
 * Change a host's description or a card's name, class, memory, memory cap, allowed job kinds and availability windows
 */
export const computeEdit = <ThrowOnError extends boolean = false>(options: Options<ComputeEditData, ThrowOnError>): RequestResult<ComputeEditResponses, ComputeEditErrors, ThrowOnError> => (options.client ?? client).patch<ComputeEditResponses, ComputeEditErrors, ThrowOnError>({
    url: '/compute/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Named credentials (name, kind, scope, last use); values are never returned
 */
export const secretsList = <ThrowOnError extends boolean = false>(options?: Options<SecretsListData, ThrowOnError>): RequestResult<SecretsListResponses, SecretsListErrors, ThrowOnError> => (options?.client ?? client).get<SecretsListResponses, SecretsListErrors, ThrowOnError>({ url: '/secrets', ...options });

/**
 * Store a named credential; the value is write-only and never returned
 */
export const secretsNew = <ThrowOnError extends boolean = false>(options: Options<SecretsNewData, ThrowOnError>): RequestResult<SecretsNewResponses, SecretsNewErrors, ThrowOnError> => (options.client ?? client).post<SecretsNewResponses, SecretsNewErrors, ThrowOnError>({
    url: '/secrets',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * The versioned defaults (defaults.yaml) every form, budget and estimate starts from
 */
export const defaultsGet = <ThrowOnError extends boolean = false>(options?: Options<DefaultsGetData, ThrowOnError>): RequestResult<DefaultsGetResponses, DefaultsGetErrors, ThrowOnError> => (options?.client ?? client).get<DefaultsGetResponses, DefaultsGetErrors, ThrowOnError>({ url: '/defaults', ...options });

/**
 * Instance-wide policies (budgets now; retention, PII and cache quotas later)
 */
export const policiesGet = <ThrowOnError extends boolean = false>(options?: Options<PoliciesGetData, ThrowOnError>): RequestResult<PoliciesGetResponses, PoliciesGetErrors, ThrowOnError> => (options?.client ?? client).get<PoliciesGetResponses, PoliciesGetErrors, ThrowOnError>({ url: '/policies', ...options });

/**
 * Change instance-wide policies; values must stay inside the ranges in defaults.yaml
 */
export const policiesEdit = <ThrowOnError extends boolean = false>(options: Options<PoliciesEditData, ThrowOnError>): RequestResult<PoliciesEditResponses, PoliciesEditErrors, ThrowOnError> => (options.client ?? client).patch<PoliciesEditResponses, PoliciesEditErrors, ThrowOnError>({
    url: '/policies',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Approvals, pending first, then the most recently decided
 */
export const approvalsList = <ThrowOnError extends boolean = false>(options?: Options<ApprovalsListData, ThrowOnError>): RequestResult<ApprovalsListResponses, ApprovalsListErrors, ThrowOnError> => (options?.client ?? client).get<ApprovalsListResponses, ApprovalsListErrors, ThrowOnError>({ url: '/approvals', ...options });

/**
 * Get an approval with its stored request and, once approved, the replay's result
 */
export const approvalsGet = <ThrowOnError extends boolean = false>(options: Options<ApprovalsGetData, ThrowOnError>): RequestResult<ApprovalsGetResponses, ApprovalsGetErrors, ThrowOnError> => (options.client ?? client).get<ApprovalsGetResponses, ApprovalsGetErrors, ThrowOnError>({ url: '/approvals/{id}', ...options });

/**
 * Approve a pending request; the stored request runs as its original actor
 */
export const approvalsApprove = <ThrowOnError extends boolean = false>(options: Options<ApprovalsApproveData, ThrowOnError>): RequestResult<ApprovalsApproveResponses, ApprovalsApproveErrors, ThrowOnError> => (options.client ?? client).post<ApprovalsApproveResponses, ApprovalsApproveErrors, ThrowOnError>({
    url: '/approvals/{id}:approve',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Deny a pending request; it never runs
 */
export const approvalsDeny = <ThrowOnError extends boolean = false>(options: Options<ApprovalsDenyData, ThrowOnError>): RequestResult<ApprovalsDenyResponses, ApprovalsDenyErrors, ThrowOnError> => (options.client ?? client).post<ApprovalsDenyResponses, ApprovalsDenyErrors, ThrowOnError>({
    url: '/approvals/{id}:deny',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * The audit log, newest first — every command, denial and failed attempt with its actor and cause
 */
export const auditList = <ThrowOnError extends boolean = false>(options?: Options<AuditListData, ThrowOnError>): RequestResult<AuditListResponses, AuditListErrors, ThrowOnError> => (options?.client ?? client).get<AuditListResponses, AuditListErrors, ThrowOnError>({ url: '/audit', ...options });

/**
 * Jobs of a project, newest first
 */
export const jobsList = <ThrowOnError extends boolean = false>(options: Options<JobsListData, ThrowOnError>): RequestResult<JobsListResponses, JobsListErrors, ThrowOnError> => (options.client ?? client).get<JobsListResponses, JobsListErrors, ThrowOnError>({ url: '/projects/{p}/jobs', ...options });

/**
 * Get a job
 */
export const jobsGet = <ThrowOnError extends boolean = false>(options: Options<JobsGetData, ThrowOnError>): RequestResult<JobsGetResponses, JobsGetErrors, ThrowOnError> => (options.client ?? client).get<JobsGetResponses, JobsGetErrors, ThrowOnError>({ url: '/jobs/{id}', ...options });

/**
 * Change a step job's priority (higher starts first; the Queue's reorder)
 */
export const jobsEdit = <ThrowOnError extends boolean = false>(options: Options<JobsEditData, ThrowOnError>): RequestResult<JobsEditResponses, JobsEditErrors, ThrowOnError> => (options.client ?? client).patch<JobsEditResponses, JobsEditErrors, ThrowOnError>({
    url: '/jobs/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Cancel a job; a queued job stops at once, a running one when its handler notices
 */
export const jobsCancel = <ThrowOnError extends boolean = false>(options: Options<JobsCancelData, ThrowOnError>): RequestResult<JobsCancelResponses, JobsCancelErrors, ThrowOnError> => (options.client ?? client).post<JobsCancelResponses, JobsCancelErrors, ThrowOnError>({ url: '/jobs/{id}:cancel', ...options });

/**
 * Wait until a job ends or the timeout passes, then return it (agents)
 */
export const jobsWait = <ThrowOnError extends boolean = false>(options: Options<JobsWaitData, ThrowOnError>): RequestResult<JobsWaitResponses, JobsWaitErrors, ThrowOnError> => (options.client ?? client).get<JobsWaitResponses, JobsWaitErrors, ThrowOnError>({ url: '/jobs/{id}:wait', ...options });

/**
 * Append a dated learning to the project's NOTES.md and commit it to main
 */
export const projectsNote = <ThrowOnError extends boolean = false>(options: Options<ProjectsNoteData, ThrowOnError>): RequestResult<ProjectsNoteResponses, ProjectsNoteErrors, ThrowOnError> => (options.client ?? client).post<ProjectsNoteResponses, ProjectsNoteErrors, ThrowOnError>({
    url: '/projects/{p}:note',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Diff the project against Cadence's current templates and skills and offer the update as a draft branch
 */
export const projectsSync = <ThrowOnError extends boolean = false>(options: Options<ProjectsSyncData, ThrowOnError>): RequestResult<ProjectsSyncResponses, ProjectsSyncErrors, ThrowOnError> => (options.client ?? client).post<ProjectsSyncResponses, ProjectsSyncErrors, ThrowOnError>({ url: '/projects/{p}:sync', ...options });

/**
 * The project's agent profile with the config files rendered from it
 */
export const agentProfileGet = <ThrowOnError extends boolean = false>(options: Options<AgentProfileGetData, ThrowOnError>): RequestResult<AgentProfileGetResponses, AgentProfileGetErrors, ThrowOnError> => (options.client ?? client).get<AgentProfileGetResponses, AgentProfileGetErrors, ThrowOnError>({ url: '/projects/{p}/agent-profile', ...options });

/**
 * Change the agent profile; the rendered config files and AGENTS.md are committed to main
 */
export const agentProfileEdit = <ThrowOnError extends boolean = false>(options: Options<AgentProfileEditData, ThrowOnError>): RequestResult<AgentProfileEditResponses, AgentProfileEditErrors, ThrowOnError> => (options.client ?? client).patch<AgentProfileEditResponses, AgentProfileEditErrors, ThrowOnError>({
    url: '/projects/{p}/agent-profile',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Agent models per driver, with the default the wizard picks
 */
export const agentModelsList = <ThrowOnError extends boolean = false>(options?: Options<AgentModelsListData, ThrowOnError>): RequestResult<AgentModelsListResponses, AgentModelsListErrors, ThrowOnError> => (options?.client ?? client).get<AgentModelsListResponses, AgentModelsListErrors, ThrowOnError>({ url: '/catalog/agent-models', ...options });

/**
 * Files of the project repository at a branch or commit
 */
export const recipesList = <ThrowOnError extends boolean = false>(options: Options<RecipesListData, ThrowOnError>): RequestResult<RecipesListResponses, RecipesListErrors, ThrowOnError> => (options.client ?? client).get<RecipesListResponses, RecipesListErrors, ThrowOnError>({ url: '/projects/{p}/recipes', ...options });

/**
 * Create one text file in the project repository and commit it to main
 */
export const recipesNew = <ThrowOnError extends boolean = false>(options: Options<RecipesNewData, ThrowOnError>): RequestResult<RecipesNewResponses, RecipesNewErrors, ThrowOnError> => (options.client ?? client).post<RecipesNewResponses, RecipesNewErrors, ThrowOnError>({
    url: '/projects/{p}/recipes',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * One file of the project repository at a branch or commit, with its commit history
 */
export const recipesGet = <ThrowOnError extends boolean = false>(options: Options<RecipesGetData, ThrowOnError>): RequestResult<RecipesGetResponses, RecipesGetErrors, ThrowOnError> => (options.client ?? client).get<RecipesGetResponses, RecipesGetErrors, ThrowOnError>({ url: '/projects/{p}/recipes/{path}', ...options });

/**
 * Write one text file of the project repository and commit it to main (the Recipe document's edits)
 */
export const recipesEdit = <ThrowOnError extends boolean = false>(options: Options<RecipesEditData, ThrowOnError>): RequestResult<RecipesEditResponses, RecipesEditErrors, ThrowOnError> => (options.client ?? client).patch<RecipesEditResponses, RecipesEditErrors, ThrowOnError>({
    url: '/projects/{p}/recipes/{path}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Open branches of the project repository (session and sync branches not merged into main)
 */
export const branchesList = <ThrowOnError extends boolean = false>(options: Options<BranchesListData, ThrowOnError>): RequestResult<BranchesListResponses, BranchesListErrors, ThrowOnError> => (options.client ?? client).get<BranchesListResponses, BranchesListErrors, ThrowOnError>({ url: '/projects/{p}/branches', ...options });

/**
 * A branch with its diff against main and the conflicts a merge would meet
 */
export const branchesGet = <ThrowOnError extends boolean = false>(options: Options<BranchesGetData, ThrowOnError>): RequestResult<BranchesGetResponses, BranchesGetErrors, ThrowOnError> => (options.client ?? client).get<BranchesGetResponses, BranchesGetErrors, ThrowOnError>({ url: '/projects/{p}/branches/{name}', ...options });

/**
 * A branch compared with main file by file in three ways (merge base, main, branch), with conflict hunks
 */
export const branchesCompare = <ThrowOnError extends boolean = false>(options: Options<BranchesCompareData, ThrowOnError>): RequestResult<BranchesCompareResponses, BranchesCompareErrors, ThrowOnError> => (options.client ?? client).get<BranchesCompareResponses, BranchesCompareErrors, ThrowOnError>({ url: '/projects/{p}/branches/{name}:compare', ...options });

/**
 * Merge a sync branch into main (fast-forward when possible, otherwise a merge commit)
 */
export const branchesAccept = <ThrowOnError extends boolean = false>(options: Options<BranchesAcceptData, ThrowOnError>): RequestResult<BranchesAcceptResponses, BranchesAcceptErrors, ThrowOnError> => (options.client ?? client).post<BranchesAcceptResponses, BranchesAcceptErrors, ThrowOnError>({ url: '/projects/{p}/branches/{name}:accept', ...options });

/**
 * Discard a sync branch without merging it
 */
export const branchesRevert = <ThrowOnError extends boolean = false>(options: Options<BranchesRevertData, ThrowOnError>): RequestResult<BranchesRevertResponses, BranchesRevertErrors, ThrowOnError> => (options.client ?? client).post<BranchesRevertResponses, BranchesRevertErrors, ThrowOnError>({ url: '/projects/{p}/branches/{name}:revert', ...options });

/**
 * Search entities of this project and the registry with free text and qualifiers
 */
export const projectsSearch = <ThrowOnError extends boolean = false>(options: Options<ProjectsSearchData, ThrowOnError>): RequestResult<ProjectsSearchResponses, ProjectsSearchErrors, ThrowOnError> => (options.client ?? client).get<ProjectsSearchResponses, ProjectsSearchErrors, ThrowOnError>({ url: '/projects/{p}:search', ...options });

/**
 * The user's saved searches in a project, by name
 */
export const viewsList = <ThrowOnError extends boolean = false>(options: Options<ViewsListData, ThrowOnError>): RequestResult<ViewsListResponses, ViewsListErrors, ThrowOnError> => (options.client ?? client).get<ViewsListResponses, ViewsListErrors, ThrowOnError>({ url: '/me/projects/{p}/views', ...options });

/**
 * Get a saved search
 */
export const viewsGet = <ThrowOnError extends boolean = false>(options: Options<ViewsGetData, ThrowOnError>): RequestResult<ViewsGetResponses, ViewsGetErrors, ThrowOnError> => (options.client ?? client).get<ViewsGetResponses, ViewsGetErrors, ThrowOnError>({ url: '/me/projects/{p}/views/{name}', ...options });

/**
 * Save a search under a name (If-Match; omit it only to create)
 */
export const viewsSet = <ThrowOnError extends boolean = false>(options: Options<ViewsSetData, ThrowOnError>): RequestResult<ViewsSetResponses, ViewsSetErrors, ThrowOnError> => (options.client ?? client).put<ViewsSetResponses, ViewsSetErrors, ThrowOnError>({
    url: '/me/projects/{p}/views/{name}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * The project's mixes, most recently changed first
 */
export const mixesList = <ThrowOnError extends boolean = false>(options: Options<MixesListData, ThrowOnError>): RequestResult<MixesListResponses, MixesListErrors, ThrowOnError> => (options.client ?? client).get<MixesListResponses, MixesListErrors, ThrowOnError>({ url: '/projects/{p}/mixes', ...options });

/**
 * Save a new mix (groups over dataset versions, weights, temperature, replay share) at revision 1
 */
export const mixesNew = <ThrowOnError extends boolean = false>(options: Options<MixesNewData, ThrowOnError>): RequestResult<MixesNewResponses, MixesNewErrors, ThrowOnError> => (options.client ?? client).post<MixesNewResponses, MixesNewErrors, ThrowOnError>({
    url: '/projects/{p}/mixes',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Hours per language and sampling shares of a mix without saving it (metadata only, no GPU)
 */
export const mixesPreview = <ThrowOnError extends boolean = false>(options: Options<MixesPreviewData, ThrowOnError>): RequestResult<MixesPreviewResponses, MixesPreviewErrors, ThrowOnError> => (options.client ?? client).post<MixesPreviewResponses, MixesPreviewErrors, ThrowOnError>({
    url: '/projects/{p}/mixes:preview',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get a mix at its current revision, with its preview and who is editing it
 */
export const mixesGet = <ThrowOnError extends boolean = false>(options: Options<MixesGetData, ThrowOnError>): RequestResult<MixesGetResponses, MixesGetErrors, ThrowOnError> => (options.client ?? client).get<MixesGetResponses, MixesGetErrors, ThrowOnError>({ url: '/mixes/{id}', ...options });

/**
 * Edit a mix; a person's edit makes a new revision, an agent's lands as a draft when the draft policy says so
 */
export const mixesEdit = <ThrowOnError extends boolean = false>(options: Options<MixesEditData, ThrowOnError>): RequestResult<MixesEditResponses, MixesEditErrors, ThrowOnError> => (options.client ?? client).patch<MixesEditResponses, MixesEditErrors, ThrowOnError>({
    url: '/mixes/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Drafts of one entity (open ones by default), newest first
 */
export const draftsList = <ThrowOnError extends boolean = false>(options: Options<DraftsListData, ThrowOnError>): RequestResult<DraftsListResponses, DraftsListErrors, ThrowOnError> => (options.client ?? client).get<DraftsListResponses, DraftsListErrors, ThrowOnError>({ url: '/drafts', ...options });

/**
 * Get a draft with its changes against the revision it was based on
 */
export const draftsGet = <ThrowOnError extends boolean = false>(options: Options<DraftsGetData, ThrowOnError>): RequestResult<DraftsGetResponses, DraftsGetErrors, ThrowOnError> => (options.client ?? client).get<DraftsGetResponses, DraftsGetErrors, ThrowOnError>({ url: '/drafts/{id}', ...options });

/**
 * Apply a draft as a new revision of its entity, attributed to the person who accepts it
 */
export const draftsAccept = <ThrowOnError extends boolean = false>(options: Options<DraftsAcceptData, ThrowOnError>): RequestResult<DraftsAcceptResponses, DraftsAcceptErrors, ThrowOnError> => (options.client ?? client).post<DraftsAcceptResponses, DraftsAcceptErrors, ThrowOnError>({ url: '/drafts/{id}:accept', ...options });

/**
 * Discard a draft; its entity stays as it is
 */
export const draftsRevert = <ThrowOnError extends boolean = false>(options: Options<DraftsRevertData, ThrowOnError>): RequestResult<DraftsRevertResponses, DraftsRevertErrors, ThrowOnError> => (options.client ?? client).post<DraftsRevertResponses, DraftsRevertErrors, ThrowOnError>({ url: '/drafts/{id}:revert', ...options });

/**
 * The project's agent sessions, live ones first, then the most recently changed
 */
export const agentSessionsList = <ThrowOnError extends boolean = false>(options: Options<AgentSessionsListData, ThrowOnError>): RequestResult<AgentSessionsListResponses, AgentSessionsListErrors, ThrowOnError> => (options.client ?? client).get<AgentSessionsListResponses, AgentSessionsListErrors, ThrowOnError>({ url: '/projects/{p}/agent-sessions', ...options });

/**
 * Start Claude Code or opencode on its own branch session/<id> of the project repository
 */
export const agentSessionsNew = <ThrowOnError extends boolean = false>(options: Options<AgentSessionsNewData, ThrowOnError>): RequestResult<AgentSessionsNewResponses, AgentSessionsNewErrors, ThrowOnError> => (options.client ?? client).post<AgentSessionsNewResponses, AgentSessionsNewErrors, ThrowOnError>({
    url: '/projects/{p}/agent-sessions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get an agent session with its state, budget and use, branch and merge state
 */
export const agentSessionsGet = <ThrowOnError extends boolean = false>(options: Options<AgentSessionsGetData, ThrowOnError>): RequestResult<AgentSessionsGetResponses, AgentSessionsGetErrors, ThrowOnError> => (options.client ?? client).get<AgentSessionsGetResponses, AgentSessionsGetErrors, ThrowOnError>({ url: '/agent-sessions/{id}', ...options });

/**
 * Stop the session's current turn; with end, also end the session
 */
export const agentSessionsCancel = <ThrowOnError extends boolean = false>(options: Options<AgentSessionsCancelData, ThrowOnError>): RequestResult<AgentSessionsCancelResponses, AgentSessionsCancelErrors, ThrowOnError> => (options.client ?? client).post<AgentSessionsCancelResponses, AgentSessionsCancelErrors, ThrowOnError>({
    url: '/agent-sessions/{id}:cancel',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Pause a session; the current turn stops, the worktree is committed and the agent process ends
 */
export const agentSessionsPause = <ThrowOnError extends boolean = false>(options: Options<AgentSessionsPauseData, ThrowOnError>): RequestResult<AgentSessionsPauseResponses, AgentSessionsPauseErrors, ThrowOnError> => (options.client ?? client).post<AgentSessionsPauseResponses, AgentSessionsPauseErrors, ThrowOnError>({ url: '/agent-sessions/{id}:pause', ...options });

/**
 * Resume a paused session (ACP session/resume, else a new ACP session with a transcript summary)
 */
export const agentSessionsResume = <ThrowOnError extends boolean = false>(options: Options<AgentSessionsResumeData, ThrowOnError>): RequestResult<AgentSessionsResumeResponses, AgentSessionsResumeErrors, ThrowOnError> => (options.client ?? client).post<AgentSessionsResumeResponses, AgentSessionsResumeErrors, ThrowOnError>({
    url: '/agent-sessions/{id}:resume',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Merge the session branch into main as a whole and end the session
 */
export const agentSessionsAccept = <ThrowOnError extends boolean = false>(options: Options<AgentSessionsAcceptData, ThrowOnError>): RequestResult<AgentSessionsAcceptResponses, AgentSessionsAcceptErrors, ThrowOnError> => (options.client ?? client).post<AgentSessionsAcceptResponses, AgentSessionsAcceptErrors, ThrowOnError>({ url: '/agent-sessions/{id}:accept', ...options });

/**
 * Discard the session branch as a whole and end the session
 */
export const agentSessionsRevert = <ThrowOnError extends boolean = false>(options: Options<AgentSessionsRevertData, ThrowOnError>): RequestResult<AgentSessionsRevertResponses, AgentSessionsRevertErrors, ThrowOnError> => (options.client ?? client).post<AgentSessionsRevertResponses, AgentSessionsRevertErrors, ThrowOnError>({ url: '/agent-sessions/{id}:revert', ...options });

/**
 * The session transcript in order, one page after a sequence number
 */
export const agentMessagesList = <ThrowOnError extends boolean = false>(options: Options<AgentMessagesListData, ThrowOnError>): RequestResult<AgentMessagesListResponses, AgentMessagesListErrors, ThrowOnError> => (options.client ?? client).get<AgentMessagesListResponses, AgentMessagesListErrors, ThrowOnError>({ url: '/agent-sessions/{id}/agent-messages', ...options });

/**
 * Send a user message with entity references; the agent answers on agent.session.{id}
 */
export const agentMessagesNew = <ThrowOnError extends boolean = false>(options: Options<AgentMessagesNewData, ThrowOnError>): RequestResult<AgentMessagesNewResponses, AgentMessagesNewErrors, ThrowOnError> => (options.client ?? client).post<AgentMessagesNewResponses, AgentMessagesNewErrors, ThrowOnError>({
    url: '/agent-sessions/{id}/agent-messages',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Long-poll for work — sessions to start, messages to deliver, controls and permission decisions
 */
export const hostSessionsClaim = <ThrowOnError extends boolean = false>(options: Options<HostSessionsClaimData, ThrowOnError>): RequestResult<HostSessionsClaimResponses, HostSessionsClaimErrors, ThrowOnError> => (options.client ?? client).post<HostSessionsClaimResponses, HostSessionsClaimErrors, ThrowOnError>({
    url: '/host-sessions:claim',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Post a batch of transcript entries, the session state, usage and the ACP session id
 */
export const hostSessionsReport = <ThrowOnError extends boolean = false>(options: Options<HostSessionsReportData, ThrowOnError>): RequestResult<HostSessionsReportResponses, HostSessionsReportErrors, ThrowOnError> => (options.client ?? client).post<HostSessionsReportResponses, HostSessionsReportErrors, ThrowOnError>({
    url: '/host-sessions/{id}:report',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Raise an ACP permission request; the preset answers it or it becomes an agent-permission approval
 */
export const hostSessionsAsk = <ThrowOnError extends boolean = false>(options: Options<HostSessionsAskData, ThrowOnError>): RequestResult<HostSessionsAskResponses, HostSessionsAskErrors, ThrowOnError> => (options.client ?? client).post<HostSessionsAskResponses, HostSessionsAskErrors, ThrowOnError>({
    url: '/host-sessions/{id}:ask',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Read (or wait for) the decision on an agent-permission approval
 */
export const hostSessionsDecision = <ThrowOnError extends boolean = false>(options: Options<HostSessionsDecisionData, ThrowOnError>): RequestResult<HostSessionsDecisionResponses, HostSessionsDecisionErrors, ThrowOnError> => (options.client ?? client).get<HostSessionsDecisionResponses, HostSessionsDecisionErrors, ThrowOnError>({ url: '/host-sessions/{id}:decision', ...options });

/**
 * The agents' model accounts (metadata only), whether an agent host is connected, and opencode's default model
 */
export const agentCredentialsList = <ThrowOnError extends boolean = false>(options?: Options<AgentCredentialsListData, ThrowOnError>): RequestResult<AgentCredentialsListResponses, AgentCredentialsListErrors, ThrowOnError> => (options?.client ?? client).get<AgentCredentialsListResponses, AgentCredentialsListErrors, ThrowOnError>({ url: '/agent-credentials', ...options });

/**
 * One agent credential's metadata (never its value)
 */
export const agentCredentialsGet = <ThrowOnError extends boolean = false>(options: Options<AgentCredentialsGetData, ThrowOnError>): RequestResult<AgentCredentialsGetResponses, AgentCredentialsGetErrors, ThrowOnError> => (options.client ?? client).get<AgentCredentialsGetResponses, AgentCredentialsGetErrors, ThrowOnError>({ url: '/agent-credentials/{id}', ...options });

/**
 * Connect or change an agent's model account (write-only value) or choose opencode's default model
 */
export const agentCredentialsSet = <ThrowOnError extends boolean = false>(options: Options<AgentCredentialsSetData, ThrowOnError>): RequestResult<AgentCredentialsSetResponses, AgentCredentialsSetErrors, ThrowOnError> => (options.client ?? client).put<AgentCredentialsSetResponses, AgentCredentialsSetErrors, ThrowOnError>({
    url: '/agent-credentials/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Ask the agent host for a tiny real request through the agent (and opencode's model list); the result arrives as an event
 */
export const agentCredentialsVerify = <ThrowOnError extends boolean = false>(options: Options<AgentCredentialsVerifyData, ThrowOnError>): RequestResult<AgentCredentialsVerifyResponses, AgentCredentialsVerifyErrors, ThrowOnError> => (options.client ?? client).post<AgentCredentialsVerifyResponses, AgentCredentialsVerifyErrors, ThrowOnError>({ url: '/agent-credentials/{id}:verify', ...options });

/**
 * Disconnect an agent's model account; the agent host removes it from the agent-credentials volume
 */
export const agentCredentialsArchive = <ThrowOnError extends boolean = false>(options: Options<AgentCredentialsArchiveData, ThrowOnError>): RequestResult<AgentCredentialsArchiveResponses, AgentCredentialsArchiveErrors, ThrowOnError> => (options.client ?? client).post<AgentCredentialsArchiveResponses, AgentCredentialsArchiveErrors, ThrowOnError>({ url: '/agent-credentials/{id}:archive', ...options });

/**
 * The provider catalogue the Agents settings choose from (Claude subscription; opencode providers and their API hosts)
 */
export const agentProvidersList = <ThrowOnError extends boolean = false>(options?: Options<AgentProvidersListData, ThrowOnError>): RequestResult<AgentProvidersListResponses, AgentProvidersListErrors, ThrowOnError> => (options?.client ?? client).get<AgentProvidersListResponses, AgentProvidersListErrors, ThrowOnError>({ url: '/agent-providers', ...options });

/**
 * Long-poll for agent credential tasks — values to write into the agent-credentials volume, removals, verifications
 */
export const hostCredentialsClaim = <ThrowOnError extends boolean = false>(options: Options<HostCredentialsClaimData, ThrowOnError>): RequestResult<HostCredentialsClaimResponses, HostCredentialsClaimErrors, ThrowOnError> => (options.client ?? client).post<HostCredentialsClaimResponses, HostCredentialsClaimErrors, ThrowOnError>({
    url: '/host-credentials:claim',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Acknowledge an agent credential task with its outcome (written, removed, verified with the model list)
 */
export const hostCredentialsReport = <ThrowOnError extends boolean = false>(options: Options<HostCredentialsReportData, ThrowOnError>): RequestResult<HostCredentialsReportResponses, HostCredentialsReportErrors, ThrowOnError> => (options.client ?? client).post<HostCredentialsReportResponses, HostCredentialsReportErrors, ThrowOnError>({
    url: '/host-credentials/{id}:report',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * The hosts the agent sandbox may reach beyond the proxy's static list (configured providers, custom base URLs)
 */
export const egressHostsList = <ThrowOnError extends boolean = false>(options?: Options<EgressHostsListData, ThrowOnError>): RequestResult<EgressHostsListResponses, EgressHostsListErrors, ThrowOnError> => (options?.client ?? client).get<EgressHostsListResponses, EgressHostsListErrors, ThrowOnError>({ url: '/egress-hosts', ...options });

/**
 * Give back every live session of a host that is shutting down, so the next host takes them at once
 *
 * The host stops its agents first (their last turn is committed and reported), then releases. Each session loses its host and token, a turn in progress counts as interrupted (the next host tells the agent, and its pending permission requests are withdrawn as interrupted, not declined), messages the host took but never gave the agent go back to pending, and the Chat shows the session as reconnecting until a host claims it.
 *
 */
export const hostSessionsRelease = <ThrowOnError extends boolean = false>(options: Options<HostSessionsReleaseData, ThrowOnError>): RequestResult<HostSessionsReleaseResponses, HostSessionsReleaseErrors, ThrowOnError> => (options.client ?? client).post<HostSessionsReleaseResponses, HostSessionsReleaseErrors, ThrowOnError>({
    url: '/host-sessions:release',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Publish the worker's runtime, step kinds and model families at start; answers the worker id
 */
export const workerRegistrationsNew = <ThrowOnError extends boolean = false>(options: Options<WorkerRegistrationsNewData, ThrowOnError>): RequestResult<WorkerRegistrationsNewResponses, WorkerRegistrationsNewErrors, ThrowOnError> => (options.client ?? client).post<WorkerRegistrationsNewResponses, WorkerRegistrationsNewErrors, ThrowOnError>({
    url: '/worker-registrations',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Long-poll for a step to run on one of this worker's cards
 */
export const workerLeasesClaim = <ThrowOnError extends boolean = false>(options: Options<WorkerLeasesClaimData, ThrowOnError>): RequestResult<WorkerLeasesClaimResponses, WorkerLeasesClaimErrors, ThrowOnError> => (options.client ?? client).post<WorkerLeasesClaimResponses, WorkerLeasesClaimErrors, ThrowOnError>({
    url: '/worker-leases:claim',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Heartbeat with progress and card telemetry; three missed beats reap the lease
 */
export const workerLeasesReport = <ThrowOnError extends boolean = false>(options: Options<WorkerLeasesReportData, ThrowOnError>): RequestResult<WorkerLeasesReportResponses, WorkerLeasesReportErrors, ThrowOnError> => (options.client ?? client).post<WorkerLeasesReportResponses, WorkerLeasesReportErrors, ThrowOnError>({
    url: '/worker-leases/{id}:report',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Append NDJSON log lines to the job's log; they stream on job.{id}.log
 */
export const workerLogsNew = <ThrowOnError extends boolean = false>(options: Options<WorkerLogsNewData, ThrowOnError>): RequestResult<WorkerLogsNewResponses, WorkerLogsNewErrors, ThrowOnError> => (options.client ?? client).post<WorkerLogsNewResponses, WorkerLogsNewErrors, ThrowOnError>({
    url: '/worker-leases/{id}/worker-logs',
    ...options,
    headers: {
        'Content-Type': 'application/x-ndjson',
        ...options.headers
    }
});

/**
 * Append a batch of metric points (loss, validation WER, LR, throughput, card memory)
 */
export const workerMetricsNew = <ThrowOnError extends boolean = false>(options: Options<WorkerMetricsNewData, ThrowOnError>): RequestResult<WorkerMetricsNewResponses, WorkerMetricsNewErrors, ThrowOnError> => (options.client ?? client).post<WorkerMetricsNewResponses, WorkerMetricsNewErrors, ThrowOnError>({
    url: '/worker-leases/{id}/worker-metrics',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Publish an intermediate output of a running step (a validation checkpoint); recorded and hooked at once
 *
 * The artifact must already be in the content store and name one of the step's outputs with its declared type. The control plane records it and runs the output hooks of its type in their own transaction (a `checkpoint` registers on the run and re-ranks its top k), so outputs published during a lease survive a pause, a window close or a failure. Publishing the same hash again is a no-op. The release still sends the step's final outputs.
 *
 */
export const workerOutputsNew = <ThrowOnError extends boolean = false>(options: Options<WorkerOutputsNewData, ThrowOnError>): RequestResult<WorkerOutputsNewResponses, WorkerOutputsNewErrors, ThrowOnError> => (options.client ?? client).post<WorkerOutputsNewResponses, WorkerOutputsNewErrors, ThrowOnError>({
    url: '/worker-leases/{id}/worker-outputs',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Complete a lease with the step's outcome, its output artifacts and final metrics, or a typed error
 */
export const workerLeasesRelease = <ThrowOnError extends boolean = false>(options: Options<WorkerLeasesReleaseData, ThrowOnError>): RequestResult<WorkerLeasesReleaseResponses, WorkerLeasesReleaseErrors, ThrowOnError> => (options.client ?? client).post<WorkerLeasesReleaseResponses, WorkerLeasesReleaseErrors, ThrowOnError>({
    url: '/worker-leases/{id}:release',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Upload a blob into the content store (workers without the shared volume); the hash is verified
 */
export const workerArtifactsSet = <ThrowOnError extends boolean = false>(options: Options<WorkerArtifactsSetData, ThrowOnError>): RequestResult<WorkerArtifactsSetResponses, WorkerArtifactsSetErrors, ThrowOnError> => (options.client ?? client).put<WorkerArtifactsSetResponses, WorkerArtifactsSetErrors, ThrowOnError>({
    bodySerializer: null,
    url: '/worker-artifacts/{hash}',
    ...options,
    headers: {
        'Content-Type': 'application/octet-stream',
        ...options.headers
    }
});

/**
 * List runtime versions (container image pinned by digest, environment lock, worker plugin) published by workers
 */
export const runtimesList = <ThrowOnError extends boolean = false>(options?: Options<RuntimesListData, ThrowOnError>): RequestResult<RuntimesListResponses, RuntimesListErrors, ThrowOnError> => (options?.client ?? client).get<RuntimesListResponses, RuntimesListErrors, ThrowOnError>({ url: '/registry/runtimes', ...options });

/**
 * Get a runtime version with the workers that run it
 */
export const runtimesGet = <ThrowOnError extends boolean = false>(options: Options<RuntimesGetData, ThrowOnError>): RequestResult<RuntimesGetResponses, RuntimesGetErrors, ThrowOnError> => (options.client ?? client).get<RuntimesGetResponses, RuntimesGetErrors, ThrowOnError>({ url: '/registry/runtimes/{id}', ...options });

/**
 * List model family versions (architecture, capabilities, latency profiles, role step kinds) published by runtimes
 */
export const modelFamiliesList = <ThrowOnError extends boolean = false>(options?: Options<ModelFamiliesListData, ThrowOnError>): RequestResult<ModelFamiliesListResponses, ModelFamiliesListErrors, ThrowOnError> => (options?.client ?? client).get<ModelFamiliesListResponses, ModelFamiliesListErrors, ThrowOnError>({ url: '/registry/model-families', ...options });

/**
 * Get a model family version
 */
export const modelFamiliesGet = <ThrowOnError extends boolean = false>(options: Options<ModelFamiliesGetData, ThrowOnError>): RequestResult<ModelFamiliesGetResponses, ModelFamiliesGetErrors, ThrowOnError> => (options.client ?? client).get<ModelFamiliesGetResponses, ModelFamiliesGetErrors, ThrowOnError>({ url: '/registry/model-families/{id}', ...options });

/**
 * List step kind versions (parameter schema with defaults, inputs, outputs, resources, runtime)
 */
export const stepKindsList = <ThrowOnError extends boolean = false>(options?: Options<StepKindsListData, ThrowOnError>): RequestResult<StepKindsListResponses, StepKindsListErrors, ThrowOnError> => (options?.client ?? client).get<StepKindsListResponses, StepKindsListErrors, ThrowOnError>({ url: '/registry/step-kinds', ...options });

/**
 * Get a step kind version
 */
export const stepKindsGet = <ThrowOnError extends boolean = false>(options: Options<StepKindsGetData, ThrowOnError>): RequestResult<StepKindsGetResponses, StepKindsGetErrors, ThrowOnError> => (options.client ?? client).get<StepKindsGetResponses, StepKindsGetErrors, ThrowOnError>({ url: '/registry/step-kinds/{id}', ...options });

/**
 * Pause a step job; a queued one is held back, a running one saves its state and returns to the queue
 */
export const jobsPause = <ThrowOnError extends boolean = false>(options: Options<JobsPauseData, ThrowOnError>): RequestResult<JobsPauseResponses, JobsPauseErrors, ThrowOnError> => (options.client ?? client).post<JobsPauseResponses, JobsPauseErrors, ThrowOnError>({ url: '/jobs/{id}:pause', ...options });

/**
 * Resume a paused step job; it waits in the queue for a free card (from its saved training state)
 */
export const jobsResume = <ThrowOnError extends boolean = false>(options: Options<JobsResumeData, ThrowOnError>): RequestResult<JobsResumeResponses, JobsResumeErrors, ThrowOnError> => (options.client ?? client).post<JobsResumeResponses, JobsResumeErrors, ThrowOnError>({ url: '/jobs/{id}:resume', ...options });

/**
 * Read a job's log lines from its worker, filtered by level and text, after a line number
 */
export const jobLogsList = <ThrowOnError extends boolean = false>(options: Options<JobLogsListData, ThrowOnError>): RequestResult<JobLogsListResponses, JobLogsListErrors, ThrowOnError> => (options.client ?? client).get<JobLogsListResponses, JobLogsListErrors, ThrowOnError>({ url: '/jobs/{id}/job-logs', ...options });

/**
 * The step queue across projects — waiting, paused and running step jobs with their card and lease
 */
export const queueEntriesList = <ThrowOnError extends boolean = false>(options?: Options<QueueEntriesListData, ThrowOnError>): RequestResult<QueueEntriesListResponses, QueueEntriesListErrors, ThrowOnError> => (options?.client ?? client).get<QueueEntriesListResponses, QueueEntriesListErrors, ThrowOnError>({ url: '/queue-entries', ...options });

/**
 * Get an artifact by hash — type, size, metadata, producing step, a directory's files, and small content
 */
export const artifactsGet = <ThrowOnError extends boolean = false>(options: Options<ArtifactsGetData, ThrowOnError>): RequestResult<ArtifactsGetResponses, ArtifactsGetErrors, ThrowOnError> => (options.client ?? client).get<ArtifactsGetResponses, ArtifactsGetErrors, ThrowOnError>({ url: '/artifacts/{hash}', ...options });

/**
 * The project's pipelines (pipelines*.yaml at a ref) and the bundled templates it does not override
 */
export const pipelinesList = <ThrowOnError extends boolean = false>(options: Options<PipelinesListData, ThrowOnError>): RequestResult<PipelinesListResponses, PipelinesListErrors, ThrowOnError> => (options.client ?? client).get<PipelinesListResponses, PipelinesListErrors, ThrowOnError>({ url: '/projects/{p}/pipelines', ...options });

/**
 * Validate a pipeline against the step registry and start a pipeline run (dryRun validates and estimates)
 */
export const pipelinesRun = <ThrowOnError extends boolean = false>(options: Options<PipelinesRunData, ThrowOnError>): RequestResult<PipelinesRunResponses, PipelinesRunErrors, ThrowOnError> => (options.client ?? client).post<PipelinesRunResponses, PipelinesRunErrors, ThrowOnError>({
    url: '/projects/{p}/pipelines/{name}:run',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Pipeline runs of a project, newest first
 */
export const pipelineRunsList = <ThrowOnError extends boolean = false>(options: Options<PipelineRunsListData, ThrowOnError>): RequestResult<PipelineRunsListResponses, PipelineRunsListErrors, ThrowOnError> => (options.client ?? client).get<PipelineRunsListResponses, PipelineRunsListErrors, ThrowOnError>({ url: '/projects/{p}/pipeline-runs', ...options });

/**
 * Get a pipeline run with the status, inputs, outputs, attempts and departures of every step
 */
export const pipelineRunsGet = <ThrowOnError extends boolean = false>(options: Options<PipelineRunsGetData, ThrowOnError>): RequestResult<PipelineRunsGetResponses, PipelineRunsGetErrors, ThrowOnError> => (options.client ?? client).get<PipelineRunsGetResponses, PipelineRunsGetErrors, ThrowOnError>({ url: '/pipeline-runs/{id}', ...options });

/**
 * Cancel a pipeline run; waiting steps never start and running step jobs are cancelled
 */
export const pipelineRunsCancel = <ThrowOnError extends boolean = false>(options: Options<PipelineRunsCancelData, ThrowOnError>): RequestResult<PipelineRunsCancelResponses, PipelineRunsCancelErrors, ThrowOnError> => (options.client ?? client).post<PipelineRunsCancelResponses, PipelineRunsCancelErrors, ThrowOnError>({ url: '/pipeline-runs/{id}:cancel', ...options });

/**
 * Retry a failed step of a pipeline run as a new attempt; the run continues from there
 */
export const pipelineRunsRetry = <ThrowOnError extends boolean = false>(options: Options<PipelineRunsRetryData, ThrowOnError>): RequestResult<PipelineRunsRetryResponses, PipelineRunsRetryErrors, ThrowOnError> => (options.client ?? client).post<PipelineRunsRetryResponses, PipelineRunsRetryErrors, ThrowOnError>({
    url: '/pipeline-runs/{id}:retry',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Wait until a pipeline run ends or the timeout passes, then return it (agents)
 */
export const pipelineRunsWait = <ThrowOnError extends boolean = false>(options: Options<PipelineRunsWaitData, ThrowOnError>): RequestResult<PipelineRunsWaitResponses, PipelineRunsWaitErrors, ThrowOnError> => (options.client ?? client).get<PipelineRunsWaitResponses, PipelineRunsWaitErrors, ThrowOnError>({ url: '/pipeline-runs/{id}:wait', ...options });

/**
 * List sources (corpora with licence, kind and languages; eval-only until cleared for training)
 */
export const sourcesList = <ThrowOnError extends boolean = false>(options?: Options<SourcesListData, ThrowOnError>): RequestResult<SourcesListResponses, SourcesListErrors, ThrowOnError> => (options?.client ?? client).get<SourcesListResponses, SourcesListErrors, ThrowOnError>({ url: '/registry/sources', ...options });

/**
 * Register a source (a corpus with its licence, kind and languages) before ingesting it; it starts eval-only
 */
export const sourcesNew = <ThrowOnError extends boolean = false>(options: Options<SourcesNewData, ThrowOnError>): RequestResult<SourcesNewResponses, SourcesNewErrors, ThrowOnError> => (options.client ?? client).post<SourcesNewResponses, SourcesNewErrors, ThrowOnError>({
    url: '/registry/sources',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get a source with its utterance count, hours and the dataset versions built from it
 */
export const sourcesGet = <ThrowOnError extends boolean = false>(options: Options<SourcesGetData, ThrowOnError>): RequestResult<SourcesGetResponses, SourcesGetErrors, ThrowOnError> => (options.client ?? client).get<SourcesGetResponses, SourcesGetErrors, ThrowOnError>({ url: '/registry/sources/{id}', ...options });

/**
 * Change a source's description or licence, or clear it for training (a person's decision)
 */
export const sourcesEdit = <ThrowOnError extends boolean = false>(options: Options<SourcesEditData, ThrowOnError>): RequestResult<SourcesEditResponses, SourcesEditErrors, ThrowOnError> => (options.client ?? client).patch<SourcesEditResponses, SourcesEditErrors, ThrowOnError>({
    url: '/registry/sources/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Archive a source (soft); it takes no new imports, its utterances and dataset versions stay
 */
export const sourcesArchive = <ThrowOnError extends boolean = false>(options: Options<SourcesArchiveData, ThrowOnError>): RequestResult<SourcesArchiveResponses, SourcesArchiveErrors, ThrowOnError> => (options.client ?? client).post<SourcesArchiveResponses, SourcesArchiveErrors, ThrowOnError>({ url: '/registry/sources/{id}:archive', ...options });

/**
 * A page of utterances (audio segments by content hash) filtered by source, dataset version, split or language
 */
export const utterancesList = <ThrowOnError extends boolean = false>(options?: Options<UtterancesListData, ThrowOnError>): RequestResult<UtterancesListResponses, UtterancesListErrors, ThrowOnError> => (options?.client ?? client).get<UtterancesListResponses, UtterancesListErrors, ThrowOnError>({ url: '/registry/utterances', ...options });

/**
 * Get an utterance with its transcripts, fingerprints and the dataset versions (and splits) that hold it
 */
export const utterancesGet = <ThrowOnError extends boolean = false>(options: Options<UtterancesGetData, ThrowOnError>): RequestResult<UtterancesGetResponses, UtterancesGetErrors, ThrowOnError> => (options.client ?? client).get<UtterancesGetResponses, UtterancesGetErrors, ThrowOnError>({ url: '/registry/utterances/{id}', ...options });

/**
 * The notification routing table — one rule per event class with its channels and timing
 */
export const notificationRulesList = <ThrowOnError extends boolean = false>(options?: Options<NotificationRulesListData, ThrowOnError>): RequestResult<NotificationRulesListResponses, NotificationRulesListErrors, ThrowOnError> => (options?.client ?? client).get<NotificationRulesListResponses, NotificationRulesListErrors, ThrowOnError>({ url: '/notification-rules', ...options });

/**
 * Change which channels an event class reaches, when, and whether Telegram rings (admin only)
 */
export const notificationRulesEdit = <ThrowOnError extends boolean = false>(options: Options<NotificationRulesEditData, ThrowOnError>): RequestResult<NotificationRulesEditResponses, NotificationRulesEditErrors, ThrowOnError> => (options.client ?? client).patch<NotificationRulesEditResponses, NotificationRulesEditErrors, ThrowOnError>({
    url: '/notification-rules/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Quiet hours, the digest time and the Telegram bot's allow-listed chats and status
 */
export const notificationSettingsGet = <ThrowOnError extends boolean = false>(options?: Options<NotificationSettingsGetData, ThrowOnError>): RequestResult<NotificationSettingsGetResponses, NotificationSettingsGetErrors, ThrowOnError> => (options?.client ?? client).get<NotificationSettingsGetResponses, NotificationSettingsGetErrors, ThrowOnError>({ url: '/notification-settings', ...options });

/**
 * Change quiet hours, the digest time or the allow-listed Telegram chats (admin only)
 */
export const notificationSettingsEdit = <ThrowOnError extends boolean = false>(options: Options<NotificationSettingsEditData, ThrowOnError>): RequestResult<NotificationSettingsEditResponses, NotificationSettingsEditErrors, ThrowOnError> => (options.client ?? client).patch<NotificationSettingsEditResponses, NotificationSettingsEditErrors, ThrowOnError>({
    url: '/notification-settings',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Store or replace the Telegram bot token (write-only, kept in the secret store as telegram-bot-token)
 */
export const telegramBotSet = <ThrowOnError extends boolean = false>(options: Options<TelegramBotSetData, ThrowOnError>): RequestResult<TelegramBotSetResponses, TelegramBotSetErrors, ThrowOnError> => (options.client ?? client).put<TelegramBotSetResponses, TelegramBotSetErrors, ThrowOnError>({
    url: '/telegram-bot',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Check the bot token with Telegram and send a test message to every allow-listed chat
 */
export const telegramBotVerify = <ThrowOnError extends boolean = false>(options: Options<TelegramBotVerifyData, ThrowOnError>): RequestResult<TelegramBotVerifyResponses, TelegramBotVerifyErrors, ThrowOnError> => (options.client ?? client).post<TelegramBotVerifyResponses, TelegramBotVerifyErrors, ThrowOnError>({ url: '/telegram-bot:verify', ...options });

/**
 * Backup sets, newest first, with the schedule and the last restore test
 */
export const backupsList = <ThrowOnError extends boolean = false>(options?: Options<BackupsListData, ThrowOnError>): RequestResult<BackupsListResponses, BackupsListErrors, ThrowOnError> => (options?.client ?? client).get<BackupsListResponses, BackupsListErrors, ThrowOnError>({ url: '/backups', ...options });

/**
 * Take a backup set now (pg_dump plus the content store); answers the job
 */
export const backupsNew = <ThrowOnError extends boolean = false>(options: Options<BackupsNewData, ThrowOnError>): RequestResult<BackupsNewResponses, BackupsNewErrors, ThrowOnError> => (options.client ?? client).post<BackupsNewResponses, BackupsNewErrors, ThrowOnError>({ url: '/backups', ...options });

/**
 * Get a backup set with its manifest and last restore test report
 */
export const backupsGet = <ThrowOnError extends boolean = false>(options: Options<BackupsGetData, ThrowOnError>): RequestResult<BackupsGetResponses, BackupsGetErrors, ThrowOnError> => (options.client ?? client).get<BackupsGetResponses, BackupsGetErrors, ThrowOnError>({ url: '/backups/{id}', ...options });

/**
 * Restore the set into a scratch database and check it (the weekly restore test, now); answers the job
 */
export const backupsVerify = <ThrowOnError extends boolean = false>(options: Options<BackupsVerifyData, ThrowOnError>): RequestResult<BackupsVerifyResponses, BackupsVerifyErrors, ThrowOnError> => (options.client ?? client).post<BackupsVerifyResponses, BackupsVerifyErrors, ThrowOnError>({ url: '/backups/{id}:verify', ...options });

/**
 * Training runs of a project, newest first
 */
export const runsList = <ThrowOnError extends boolean = false>(options: Options<RunsListData, ThrowOnError>): RequestResult<RunsListResponses, RunsListErrors, ThrowOnError> => (options.client ?? client).get<RunsListResponses, RunsListErrors, ThrowOnError>({ url: '/projects/{p}/runs', ...options });

/**
 * Start a training run (one optimisation stage); ?dryRun=true answers the estimate first
 */
export const runsNew = <ThrowOnError extends boolean = false>(options: Options<RunsNewData, ThrowOnError>): RequestResult<RunsNewResponses, RunsNewErrors, ThrowOnError> => (options.client ?? client).post<RunsNewResponses, RunsNewErrors, ThrowOnError>({
    url: '/projects/{p}/runs',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Measure seconds per step and batch sizes for a base model on the training card (the family's calibrate step)
 */
export const runsCalibrate = <ThrowOnError extends boolean = false>(options: Options<RunsCalibrateData, ThrowOnError>): RequestResult<RunsCalibrateResponses, RunsCalibrateErrors, ThrowOnError> => (options.client ?? client).post<RunsCalibrateResponses, RunsCalibrateErrors, ThrowOnError>({
    url: '/projects/{p}/runs:calibrate',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get a run with its stage timeline, final metrics, departures from defaults and parent run
 */
export const runsGet = <ThrowOnError extends boolean = false>(options: Options<RunsGetData, ThrowOnError>): RequestResult<RunsGetResponses, RunsGetErrors, ThrowOnError> => (options.client ?? client).get<RunsGetResponses, RunsGetErrors, ThrowOnError>({ url: '/runs/{id}', ...options });

/**
 * Continue a stopped or failed run from its last training state (same stage, same optimiser state)
 */
export const runsResume = <ThrowOnError extends boolean = false>(options: Options<RunsResumeData, ThrowOnError>): RequestResult<RunsResumeResponses, RunsResumeErrors, ThrowOnError> => (options.client ?? client).post<RunsResumeResponses, RunsResumeErrors, ThrowOnError>({ url: '/runs/{id}:resume', ...options });

/**
 * Start a new stage from a checkpoint of this run with an explicit peak learning rate
 */
export const runsStage = <ThrowOnError extends boolean = false>(options: Options<RunsStageData, ThrowOnError>): RequestResult<RunsStageResponses, RunsStageErrors, ThrowOnError> => (options.client ?? client).post<RunsStageResponses, RunsStageErrors, ThrowOnError>({
    url: '/runs/{id}:stage',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Checkpoints of a project or of one run, best validation WER first
 */
export const checkpointsList = <ThrowOnError extends boolean = false>(options: Options<CheckpointsListData, ThrowOnError>): RequestResult<CheckpointsListResponses, CheckpointsListErrors, ThrowOnError> => (options.client ?? client).get<CheckpointsListResponses, CheckpointsListErrors, ThrowOnError>({ url: '/projects/{p}/checkpoints', ...options });

/**
 * Get a checkpoint with its artifact, metrics and lineage
 */
export const checkpointsGet = <ThrowOnError extends boolean = false>(options: Options<CheckpointsGetData, ThrowOnError>): RequestResult<CheckpointsGetResponses, CheckpointsGetErrors, ThrowOnError> => (options.client ?? client).get<CheckpointsGetResponses, CheckpointsGetErrors, ThrowOnError>({ url: '/checkpoints/{id}', ...options });

/**
 * Average chosen checkpoints of a run with the family's average step; the result is a new checkpoint of the run
 */
export const checkpointsAverage = <ThrowOnError extends boolean = false>(options: Options<CheckpointsAverageData, ThrowOnError>): RequestResult<CheckpointsAverageResponses, CheckpointsAverageErrors, ThrowOnError> => (options.client ?? client).post<CheckpointsAverageResponses, CheckpointsAverageErrors, ThrowOnError>({
    url: '/runs/{id}/checkpoints:average',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * A run's metric series, binned server-side for charts (min and max per bucket), with checkpoint marks
 */
export const metricsGet = <ThrowOnError extends boolean = false>(options: Options<MetricsGetData, ThrowOnError>): RequestResult<MetricsGetResponses, MetricsGetErrors, ThrowOnError> => (options.client ?? client).get<MetricsGetResponses, MetricsGetErrors, ThrowOnError>({ url: '/metrics/{id}', ...options });

/**
 * The playbooks Cadence ships, with their inputs, chain, stop conditions and estimate
 */
export const playbooksList = <ThrowOnError extends boolean = false>(options?: Options<PlaybooksListData, ThrowOnError>): RequestResult<PlaybooksListResponses, PlaybooksListErrors, ThrowOnError> => (options?.client ?? client).get<PlaybooksListResponses, PlaybooksListErrors, ThrowOnError>({ url: '/playbooks', ...options });

/**
 * One playbook with its inputs, chain, prompt template and estimate
 */
export const playbooksGet = <ThrowOnError extends boolean = false>(options: Options<PlaybooksGetData, ThrowOnError>): RequestResult<PlaybooksGetResponses, PlaybooksGetErrors, ThrowOnError> => (options.client ?? client).get<PlaybooksGetResponses, PlaybooksGetErrors, ThrowOnError>({ url: '/playbooks/{name}', ...options });

/**
 * Start a playbook session — dryRun answers the estimate, the plan and the rendered prompt without starting
 */
export const playbooksRun = <ThrowOnError extends boolean = false>(options: Options<PlaybooksRunData, ThrowOnError>): RequestResult<PlaybooksRunResponses, PlaybooksRunErrors, ThrowOnError> => (options.client ?? client).post<PlaybooksRunResponses, PlaybooksRunErrors, ThrowOnError>({
    url: '/projects/{p}/playbooks/{name}:run',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Free content-store space by deleting superseded training states (always waits for an approval)
 */
export const artifactsEvict = <ThrowOnError extends boolean = false>(options: Options<ArtifactsEvictData, ThrowOnError>): RequestResult<ArtifactsEvictResponses, ArtifactsEvictErrors, ThrowOnError> => (options.client ?? client).post<ArtifactsEvictResponses, ArtifactsEvictErrors, ThrowOnError>({
    url: '/artifacts:evict',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List scoring normalizer versions (the text rules both sides of a WER are compared after, R21)
 */
export const normalizersList = <ThrowOnError extends boolean = false>(options?: Options<NormalizersListData, ThrowOnError>): RequestResult<NormalizersListResponses, NormalizersListErrors, ThrowOnError> => (options?.client ?? client).get<NormalizersListResponses, NormalizersListErrors, ThrowOnError>({ url: '/registry/normalizers', ...options });

/**
 * Get a scoring normalizer version with its rules and the projects that use it
 */
export const normalizersGet = <ThrowOnError extends boolean = false>(options: Options<NormalizersGetData, ThrowOnError>): RequestResult<NormalizersGetResponses, NormalizersGetErrors, ThrowOnError> => (options.client ?? client).get<NormalizersGetResponses, NormalizersGetErrors, ThrowOnError>({ url: '/registry/normalizers/{id}', ...options });

/**
 * List golden set versions (frozen eval-only dataset versions tied to a scoring normalizer)
 */
export const goldenSetsList = <ThrowOnError extends boolean = false>(options?: Options<GoldenSetsListData, ThrowOnError>): RequestResult<GoldenSetsListResponses, GoldenSetsListErrors, ThrowOnError> => (options?.client ?? client).get<GoldenSetsListResponses, GoldenSetsListErrors, ThrowOnError>({ url: '/registry/golden-sets', ...options });

/**
 * Get a golden set version with its dataset, normalizer, size and the projects that use it
 */
export const goldenSetsGet = <ThrowOnError extends boolean = false>(options: Options<GoldenSetsGetData, ThrowOnError>): RequestResult<GoldenSetsGetResponses, GoldenSetsGetErrors, ThrowOnError> => (options.client ?? client).get<GoldenSetsGetResponses, GoldenSetsGetErrors, ThrowOnError>({ url: '/registry/golden-sets/{id}', ...options });

/**
 * Freeze an eval-only dataset version and a scoring normalizer into a golden set (always waits for the admin's approval)
 */
export const goldenSetsFreeze = <ThrowOnError extends boolean = false>(options: Options<GoldenSetsFreezeData, ThrowOnError>): RequestResult<GoldenSetsFreezeResponses, GoldenSetsFreezeErrors, ThrowOnError> => (options.client ?? client).post<GoldenSetsFreezeResponses, GoldenSetsFreezeErrors, ThrowOnError>({
    url: '/registry/golden-sets:freeze',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List the project's evals, newest first (cells omitted; evals.get has them)
 */
export const evalsList = <ThrowOnError extends boolean = false>(options: Options<EvalsListData, ThrowOnError>): RequestResult<EvalsListResponses, EvalsListErrors, ThrowOnError> => (options.client ?? client).get<EvalsListResponses, EvalsListErrors, ThrowOnError>({ url: '/projects/{p}/evals', ...options });

/**
 * Evaluate a checkpoint, model or base model against the baseline on golden sets × latency profiles × decoding; ?dryRun=true answers the plan
 */
export const evalsNew = <ThrowOnError extends boolean = false>(options: Options<EvalsNewData, ThrowOnError>): RequestResult<EvalsNewResponses, EvalsNewErrors, ThrowOnError> => (options.client ?? client).post<EvalsNewResponses, EvalsNewErrors, ThrowOnError>({
    url: '/projects/{p}/evals',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get an eval with its cells, deltas against the baseline with confidence intervals, and the worst utterances of a cell
 */
export const evalsGet = <ThrowOnError extends boolean = false>(options: Options<EvalsGetData, ThrowOnError>): RequestResult<EvalsGetResponses, EvalsGetErrors, ThrowOnError> => (options.client ?? client).get<EvalsGetResponses, EvalsGetErrors, ThrowOnError>({ url: '/evals/{id}', ...options });

/**
 * Apply the project's gate (gates.yaml at main) to a finished eval and record the verdict
 */
export const evalsGate = <ThrowOnError extends boolean = false>(options: Options<EvalsGateData, ThrowOnError>): RequestResult<EvalsGateResponses, EvalsGateErrors, ThrowOnError> => (options.client ?? client).post<EvalsGateResponses, EvalsGateErrors, ThrowOnError>({ url: '/evals/{id}:gate', ...options });

/**
 * Get the project's gate (gates.yaml at main, with the defaults it departs from)
 */
export const gatesGet = <ThrowOnError extends boolean = false>(options: Options<GatesGetData, ThrowOnError>): RequestResult<GatesGetResponses, GatesGetErrors, ThrowOnError> => (options.client ?? client).get<GatesGetResponses, GatesGetErrors, ThrowOnError>({ url: '/projects/{p}/gates', ...options });

/**
 * Commit a new gates.yaml to main (approval for agents); dryRun validates
 */
export const gatesEdit = <ThrowOnError extends boolean = false>(options: Options<GatesEditData, ThrowOnError>): RequestResult<GatesEditResponses, GatesEditErrors, ThrowOnError> => (options.client ?? client).patch<GatesEditResponses, GatesEditErrors, ThrowOnError>({
    url: '/projects/{p}/gates',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Register a checkpoint whose latest gated eval passed as a model version, with its model card (approval for agents)
 */
export const modelsRegister = <ThrowOnError extends boolean = false>(options: Options<ModelsRegisterData, ThrowOnError>): RequestResult<ModelsRegisterResponses, ModelsRegisterErrors, ThrowOnError> => (options.client ?? client).post<ModelsRegisterResponses, ModelsRegisterErrors, ThrowOnError>({
    url: '/projects/{p}/models:register',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List registered model versions (checkpoints whose gate passed) with their gate and lineage
 */
export const modelsList = <ThrowOnError extends boolean = false>(options?: Options<ModelsListData, ThrowOnError>): RequestResult<ModelsListResponses, ModelsListErrors, ThrowOnError> => (options?.client ?? client).get<ModelsListResponses, ModelsListErrors, ThrowOnError>({ url: '/registry/models', ...options });

/**
 * Get a model version with its model card, gate, lineage and the projects that use it
 */
export const modelsGet = <ThrowOnError extends boolean = false>(options: Options<ModelsGetData, ThrowOnError>): RequestResult<ModelsGetResponses, ModelsGetErrors, ThrowOnError> => (options.client ?? client).get<ModelsGetResponses, ModelsGetErrors, ThrowOnError>({ url: '/registry/models/{id}', ...options });

/**
 * The project's language packs (lang/<locale>/ on main) and the locales Cadence ships packs for
 */
export const langpacksList = <ThrowOnError extends boolean = false>(options: Options<LangpacksListData, ThrowOnError>): RequestResult<LangpacksListResponses, LangpacksListErrors, ThrowOnError> => (options.client ?? client).get<LangpacksListResponses, LangpacksListErrors, ThrowOnError>({ url: '/projects/{p}/langpacks', ...options });

/**
 * One language pack with its files, scoring normalizer and boost lists; ETag is the pack's commit
 */
export const langpacksGet = <ThrowOnError extends boolean = false>(options: Options<LangpacksGetData, ThrowOnError>): RequestResult<LangpacksGetResponses, LangpacksGetErrors, ThrowOnError> => (options.client ?? client).get<LangpacksGetResponses, LangpacksGetErrors, ThrowOnError>({ url: '/projects/{p}/langpacks/{locale}', ...options });

/**
 * Write or delete files of one language pack in one commit (If-Match is the pack's commit)
 */
export const langpacksEdit = <ThrowOnError extends boolean = false>(options: Options<LangpacksEditData, ThrowOnError>): RequestResult<LangpacksEditResponses, LangpacksEditErrors, ThrowOnError> => (options.client ?? client).patch<LangpacksEditResponses, LangpacksEditErrors, ThrowOnError>({
    url: '/projects/{p}/langpacks/{locale}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Replace one boost list of a language pack (terms and weight) in one commit
 */
export const boostEdit = <ThrowOnError extends boolean = false>(options: Options<BoostEditData, ThrowOnError>): RequestResult<BoostEditResponses, BoostEditErrors, ThrowOnError> => (options.client ?? client).patch<BoostEditResponses, BoostEditErrors, ThrowOnError>({
    url: '/projects/{p}/langpacks/{locale}/boost/{domain}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * The lineage graph around an entity — what it was built from (upstream) and what uses it (downstream)
 */
export const registryLineage = <ThrowOnError extends boolean = false>(options: Options<RegistryLineageData, ThrowOnError>): RequestResult<RegistryLineageResponses, RegistryLineageErrors, ThrowOnError> => (options.client ?? client).get<RegistryLineageResponses, RegistryLineageErrors, ThrowOnError>({ url: '/registry/{id}:lineage', ...options });

/**
 * List the project's experiments, newest first (question, mix, base model, run count, best run, sweeps)
 */
export const experimentsList = <ThrowOnError extends boolean = false>(options: Options<ExperimentsListData, ThrowOnError>): RequestResult<ExperimentsListResponses, ExperimentsListErrors, ThrowOnError> => (options.client ?? client).get<ExperimentsListResponses, ExperimentsListErrors, ThrowOnError>({ url: '/projects/{p}/experiments', ...options });

/**
 * Open an experiment — a question with a fixed mix revision and base model — that runs and sweeps join
 */
export const experimentsNew = <ThrowOnError extends boolean = false>(options: Options<ExperimentsNewData, ThrowOnError>): RequestResult<ExperimentsNewResponses, ExperimentsNewErrors, ThrowOnError> => (options.client ?? client).post<ExperimentsNewResponses, ExperimentsNewErrors, ThrowOnError>({
    url: '/projects/{p}/experiments',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get an experiment with its runs as parameters × metrics, the best run by validation WER, and its sweeps
 */
export const experimentsGet = <ThrowOnError extends boolean = false>(options: Options<ExperimentsGetData, ThrowOnError>): RequestResult<ExperimentsGetResponses, ExperimentsGetErrors, ThrowOnError> => (options.client ?? client).get<ExperimentsGetResponses, ExperimentsGetErrors, ThrowOnError>({ url: '/experiments/{id}', ...options });

/**
 * Run a grid or random sweep over recipe parameters as sequential runs of the experiment under a GPU-hour cap
 */
export const sweepsRun = <ThrowOnError extends boolean = false>(options: Options<SweepsRunData, ThrowOnError>): RequestResult<SweepsRunResponses, SweepsRunErrors, ThrowOnError> => (options.client ?? client).post<SweepsRunResponses, SweepsRunErrors, ThrowOnError>({
    url: '/experiments/{id}/sweeps:run',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * A span of an utterance's audio as 16 kHz 16-bit PCM WAV, with byte ranges; a signed link plays without a session
 *
 * The utterance's audio, or a span of it, as a 16 kHz 16-bit PCM WAV file (the stored file itself when it is already one and the whole file is asked). Byte ranges (Range: bytes=…) answer 206 Partial Content. A request signed by audio.sign (exp, viewer, sig) needs no session and is attributed to its viewer. Every play — a request from byte 0 — is written to the audit log with the viewer and the span. Agent session tokens are refused.
 *
 */
export const audioGet = <ThrowOnError extends boolean = false>(options: Options<AudioGetData, ThrowOnError>): RequestResult<AudioGetResponses, AudioGetErrors, ThrowOnError> => (options.client ?? client).get<AudioGetResponses, AudioGetErrors, ThrowOnError>({ url: '/registry/utterances/{id}/audio', ...options });

/**
 * Mint a short-lived signed link that plays a span of an utterance (bound to the span, the viewer and an expiry)
 *
 * A link a media element can play without headers: audio.get with exp, viewer and sig. It is bound to the utterance, the span, the channel and the signed-in viewer, and expires after defaults media.signed_link_ttl_s. Minting writes an audit row (who, which span). Not a command: it changes no entity, so it takes no Idempotency-Key, If-Match or dryRun. Agent session tokens are refused.
 *
 */
export const audioSign = <ThrowOnError extends boolean = false>(options: Options<AudioSignData, ThrowOnError>): RequestResult<AudioSignResponses, AudioSignErrors, ThrowOnError> => (options.client ?? client).post<AudioSignResponses, AudioSignErrors, ThrowOnError>({
    url: '/registry/utterances/{id}/audio:sign',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Min/max peaks per channel of an utterance (or a span) at a resolution, for the waveform track
 *
 * int8 min/max pairs (value / 127 = sample) per hop and channel, frames × channels × [min, max], base64. Peaks are stored once per audio as a peaks artifact (cadence.peaks/2): the 10 ms base level and, for long audio, coarser levels (×16 each), computed when a dataset version is registered (a frozen version's members, and a draft's segments whose files the control plane reads without a decoder) by the media.peaks job. A request reads only the span it asks for from the coarsest stored level that divides hopMs and pools it; audio with no stored peaks is computed on this request and stored (computed: true).
 *
 */
export const peaksGet = <ThrowOnError extends boolean = false>(options: Options<PeaksGetData, ThrowOnError>): RequestResult<PeaksGetResponses, PeaksGetErrors, ThrowOnError> => (options.client ?? client).get<PeaksGetResponses, PeaksGetErrors, ThrowOnError>({ url: '/registry/utterances/{id}/peaks', ...options });

/**
 * The spectrogram tile pyramid of an utterance's audio — its manifest, or one tile; the first request builds it
 *
 * For audio longer than views.audio.browser_stft_max_s the audio view reads a server tile pyramid: the newest spectrogram_tiles artifact of the utterance's audio at the views.audio settings (or one spectrogram_tiles@1 wrote in a pipeline). Without tile: the manifest (JSON). With tile=c<ch>/l<level>/<index>: that tile's bytes (uint8 dB, bins × 512 frames, dB = -120 + 0.5 × value). When no pyramid exists, a manifest request starts the media.spectrogram job that builds it once in the control plane (any audio the view plays: a stored utterance, a segment or window of a file on a mount) and answers 202 with the job (Retry-After 2); requests while it runs answer the same job, so each audio is built once. A failed build answers media-tiles-failed until media.tiles_retry_s has passed, then builds again; audio longer than media.tiles_max_s is refused. Narrowband audio (8 kHz origin by its estimated bandwidth) keeps bins up to 4 kHz (manifest narrowband, bandwidthHz). A tile request with no pyramid answers 404.
 *
 */
export const spectrogramGet = <ThrowOnError extends boolean = false>(options: Options<SpectrogramGetData, ThrowOnError>): RequestResult<SpectrogramGetResponses, SpectrogramGetErrors, ThrowOnError> => (options.client ?? client).get<SpectrogramGetResponses, SpectrogramGetErrors, ThrowOnError>({ url: '/registry/utterances/{id}/spectrogram', ...options });

/**
 * An utterance's hypothesis words with times (marked S/D/I against the reference by a scores artifact) and its reference words at aligned times
 *
 * The audio view's word tracks for one utterance: its row of a hypotheses artifact (words with start, end and confidence; partial events of a streaming decode), and, with scores, the alignment of that utterance's row in the scores artifact — each hypothesis word marked =, S or I (with the reference word for S), and the reference words the hypothesis deleted placed between hypothesis words. With goldenSet (or alignment), the reference track: the utterance's row of the golden set's newest reference alignment (align_reference) — its words at their aligned times, or the text and the reason when it stayed unaligned. At least one of hypotheses, goldenSet and alignment is required.
 *
 */
export const wordsGet = <ThrowOnError extends boolean = false>(options: Options<WordsGetData, ThrowOnError>): RequestResult<WordsGetResponses, WordsGetErrors, ThrowOnError> => (options.client ?? client).get<WordsGetResponses, WordsGetErrors, ThrowOnError>({ url: '/registry/utterances/{id}/words', ...options });

/**
 * Open a manual transcription test of one to three models on a file, the microphone or an utterance span; answers the live socket's URL and a single-use ticket
 *
 * A manual test (R47): one to three targets (a checkpoint, a model version or a base model version, each with its latency profile, language and optional boost list) receive the same audio and stream partial and final words back over the live channel (stream.connect, R48). The answer carries the session (trs_…), the socket URL and a single-use ticket valid transcriptions.ticket_ttl_s (60 s); the socket also checks Origin. The session is an interactive job (R49): it reserves the family's interactive memory on a card beside training under the card's cap, never beside a benchmark, at the highest queue priority, and counts against the project's daily budgets.manual_test_gpu_hours_per_project_per_day (lease wall time). One open session per person, at most transcriptions.session_max_minutes long, closed after transcriptions.idle_minutes without audio or keepalive. Nothing else is stored: no audio, text or metric. ?dryRun=true checks the targets and the allowance and answers the session without opening it (no ticket). Agent session tokens are refused.
 *
 */
export const transcriptionsNew = <ThrowOnError extends boolean = false>(options: Options<TranscriptionsNewData, ThrowOnError>): RequestResult<TranscriptionsNewResponses, TranscriptionsNewErrors, ThrowOnError> => (options.client ?? client).post<TranscriptionsNewResponses, TranscriptionsNewErrors, ThrowOnError>({
    url: '/projects/{p}/transcriptions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * The live channel of a transcription session — a WebSocket opened with the session's single-use ticket from a same-origin page
 *
 * Upgrades to a WebSocket (no WebRTC, R48). The ticket from transcriptions.new is single-use and valid 60 s; the Origin header must name this server (or one of CADENCE_ALLOWED_ORIGINS); the signed-in user must be the session's. Client → server: text frames are LiveClientMessage (start first, then fileEnd, finalize, keepalive, ping, end) and binary frames carry audio — PCM16 little-endian mono at the capture rate in frames of at most transcriptions.frame_ms (20 ms) for the microphone, or a file's bytes. Server → client: LiveServerMessage (waiting while the job is queued or loading, started, partial, final, stats, pong, error, summary). The socket closes with 1000 after summary; 4001 idle, 4002 session cap, 4003 the worker was lost, 4004 the job could not start, 1013 backpressure (the worker fell behind), 1001 the control plane is stopping.
 *
 */
export const streamConnect = <ThrowOnError extends boolean = false>(options: Options<StreamConnectData, ThrowOnError>): RequestResult<StreamConnectResponses, StreamConnectErrors, ThrowOnError> => (options.client ?? client).get<StreamConnectResponses, StreamConnectErrors, ThrowOnError>({ url: '/transcriptions/{id}/stream', ...options });

/**
 * A worker's live job dials out to its session (WebSocket) and receives the browser's messages unchanged
 *
 * The pull model of R14 for the live channel: a worker running an interactive job (a family's live role kind) loads every target, then dials this socket with the lease's live token (header Cadence-Live-Token, from the lease's env CADENCE_LIVE_TOKEN) or its worker credential (Bearer cwk_…, the lease's host). The relay forwards the browser's frames byte for byte (it reads only "type") and the worker's LiveServerMessage frames back. One dial serves one session; a dial for a session that ended answers 409 lease-ended.
 *
 */
export const workerLiveConnect = <ThrowOnError extends boolean = false>(options: Options<WorkerLiveConnectData, ThrowOnError>): RequestResult<WorkerLiveConnectResponses, WorkerLiveConnectErrors, ThrowOnError> => (options.client ?? client).get<WorkerLiveConnectResponses, WorkerLiveConnectErrors, ThrowOnError>({ url: '/worker-live/{jobId}', ...options });

/**
 * Registered mounts with their health and last scan
 */
export const mountsList = <ThrowOnError extends boolean = false>(options?: Options<MountsListData, ThrowOnError>): RequestResult<MountsListResponses, MountsListErrors, ThrowOnError> => (options?.client ?? client).get<MountsListResponses, MountsListErrors, ThrowOnError>({ url: '/mounts', ...options });

/**
 * Register a local path, NFS/SMB path, S3-compatible bucket or Hub repository (registry approval, the admin decides)
 */
export const mountsNew = <ThrowOnError extends boolean = false>(options: Options<MountsNewData, ThrowOnError>): RequestResult<MountsNewResponses, MountsNewErrors, ThrowOnError> => (options.client ?? client).post<MountsNewResponses, MountsNewErrors, ThrowOnError>({
    url: '/mounts',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get a mount with its health, last scan, utterance URIs and content-store copies
 */
export const mountsGet = <ThrowOnError extends boolean = false>(options: Options<MountsGetData, ThrowOnError>): RequestResult<MountsGetResponses, MountsGetErrors, ThrowOnError> => (options.client ?? client).get<MountsGetResponses, MountsGetErrors, ThrowOnError>({ url: '/mounts/{id}', ...options });

/**
 * Rescan a mount — files, bytes, top-level entries and content-store blob copies — and check its health (202 with the job)
 */
export const mountsScan = <ThrowOnError extends boolean = false>(options: Options<MountsScanData, ThrowOnError>): RequestResult<MountsScanResponses, MountsScanErrors, ThrowOnError> => (options.client ?? client).post<MountsScanResponses, MountsScanErrors, ThrowOnError>({
    url: '/mounts/{id}:scan',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Check a mount's health on a worker now — reachable, free space, a throughput sample (202 with the job)
 */
export const mountsVerify = <ThrowOnError extends boolean = false>(options: Options<MountsVerifyData, ThrowOnError>): RequestResult<MountsVerifyResponses, MountsVerifyErrors, ThrowOnError> => (options.client ?? client).post<MountsVerifyResponses, MountsVerifyErrors, ThrowOnError>({ url: '/mounts/{id}:verify', ...options });

/**
 * Cache use, water marks, per-project quotas, pinned and evictable dataset versions
 */
export const storageGet = <ThrowOnError extends boolean = false>(options?: Options<StorageGetData, ThrowOnError>): RequestResult<StorageGetResponses, StorageGetErrors, ThrowOnError> => (options?.client ?? client).get<StorageGetResponses, StorageGetErrors, ThrowOnError>({ url: '/storage', ...options });

/**
 * Copy a dataset version's evicted shards back into the local cache from their mount copies (resumable job)
 */
export const datasetsMaterialize = <ThrowOnError extends boolean = false>(options: Options<DatasetsMaterializeData, ThrowOnError>): RequestResult<DatasetsMaterializeResponses, DatasetsMaterializeErrors, ThrowOnError> => (options.client ?? client).post<DatasetsMaterializeResponses, DatasetsMaterializeErrors, ThrowOnError>({
    url: '/registry/datasets:materialize',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Free a dataset version's shards from the local cache when every shard also lives on a mount (202 with the job)
 */
export const datasetsEvict = <ThrowOnError extends boolean = false>(options: Options<DatasetsEvictData, ThrowOnError>): RequestResult<DatasetsEvictResponses, DatasetsEvictErrors, ThrowOnError> => (options.client ?? client).post<DatasetsEvictResponses, DatasetsEvictErrors, ThrowOnError>({
    url: '/registry/datasets:evict',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Export a frozen dataset version as Lhotse Shar, a NeMo manifest or a Cadence bundle (to a writable mount or the content store), or to the Hugging Face Hub (approval); 202 with the job
 */
export const datasetsExport = <ThrowOnError extends boolean = false>(options: Options<DatasetsExportData, ThrowOnError>): RequestResult<DatasetsExportResponses, DatasetsExportErrors, ThrowOnError> => (options.client ?? client).post<DatasetsExportResponses, DatasetsExportErrors, ThrowOnError>({
    url: '/registry/datasets:export',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Dataset exports run in a project, newest first
 */
export const exportsList = <ThrowOnError extends boolean = false>(options: Options<ExportsListData, ThrowOnError>): RequestResult<ExportsListResponses, ExportsListErrors, ThrowOnError> => (options.client ?? client).get<ExportsListResponses, ExportsListErrors, ThrowOnError>({ url: '/projects/{p}/exports', ...options });

/**
 * Get a dataset export with its state, target, files, bytes, mount copies and Hub commit
 */
export const exportsGet = <ThrowOnError extends boolean = false>(options: Options<ExportsGetData, ThrowOnError>): RequestResult<ExportsGetResponses, ExportsGetErrors, ThrowOnError> => (options.client ?? client).get<ExportsGetResponses, ExportsGetErrors, ThrowOnError>({ url: '/exports/{id}', ...options });

/**
 * The annotation guidelines a batch pinned — the Markdown file at the batch's commit of the project repository
 */
export const guidelinesGet = <ThrowOnError extends boolean = false>(options: Options<GuidelinesGetData, ThrowOnError>): RequestResult<GuidelinesGetResponses, GuidelinesGetErrors, ThrowOnError> => (options.client ?? client).get<GuidelinesGetResponses, GuidelinesGetErrors, ThrowOnError>({ url: '/batches/{id}/guidelines', ...options });

/**
 * Read a text of the content store the registry names to be read — a dataset version's card (Markdown)
 */
export const textsGet = <ThrowOnError extends boolean = false>(options: Options<TextsGetData, ThrowOnError>): RequestResult<TextsGetResponses, TextsGetErrors, ThrowOnError> => (options.client ?? client).get<TextsGetResponses, TextsGetErrors, ThrowOnError>({ url: '/registry/texts/{hash}', ...options });

/**
 * Export the project as a Cadence project bundle (its repository at a commit, data.lock and every registry version it references, with their content) to a directory on a writable mount; 201 with the export
 */
export const projectsExport = <ThrowOnError extends boolean = false>(options: Options<ProjectsExportData, ThrowOnError>): RequestResult<ProjectsExportResponses, ProjectsExportErrors, ThrowOnError> => (options.client ?? client).post<ProjectsExportResponses, ProjectsExportErrors, ThrowOnError>({
    url: '/projects/{p}:export',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Import a Cadence project bundle's registry versions this instance lacks and adopt every version the bundle's project adopted into this project (approval for everyone); 201 with the import job
 */
export const bundlesAdopt = <ThrowOnError extends boolean = false>(options: Options<BundlesAdoptData, ThrowOnError>): RequestResult<BundlesAdoptResponses, BundlesAdoptErrors, ThrowOnError> => (options.client ?? client).post<BundlesAdoptResponses, BundlesAdoptErrors, ThrowOnError>({
    url: '/projects/{p}/bundles:adopt',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Hours per language and split of a dataset version after filters (metadata only; nothing is written)
 */
export const datasetsPreview = <ThrowOnError extends boolean = false>(options: Options<DatasetsPreviewData, ThrowOnError>): RequestResult<DatasetsPreviewResponses, DatasetsPreviewErrors, ThrowOnError> => (options.client ?? client).post<DatasetsPreviewResponses, DatasetsPreviewErrors, ThrowOnError>({
    url: '/registry/datasets:preview',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Freeze a draft dataset version — leakage check, then cut its segments into the content store (202 with the pipeline run)
 */
export const datasetsFreeze = <ThrowOnError extends boolean = false>(options: Options<DatasetsFreezeData, ThrowOnError>): RequestResult<DatasetsFreezeResponses, DatasetsFreezeErrors, ThrowOnError> => (options.client ?? client).post<DatasetsFreezeResponses, DatasetsFreezeErrors, ThrowOnError>({
    url: '/registry/datasets:freeze',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Search utterances by transcript text, source, language, speaker, duration, origin and split
 */
export const utterancesSearch = <ThrowOnError extends boolean = false>(options?: Options<UtterancesSearchData, ThrowOnError>): RequestResult<UtterancesSearchResponses, UtterancesSearchErrors, ThrowOnError> => (options?.client ?? client).get<UtterancesSearchResponses, UtterancesSearchErrors, ThrowOnError>({ url: '/registry/utterances:search', ...options });

/**
 * List auxiliary model versions (LID classifiers, pseudo-label members, aligners) with their licence check
 */
export const auxiliariesList = <ThrowOnError extends boolean = false>(options?: Options<AuxiliariesListData, ThrowOnError>): RequestResult<AuxiliariesListResponses, AuxiliariesListErrors, ThrowOnError> => (options?.client ?? client).get<AuxiliariesListResponses, AuxiliariesListErrors, ThrowOnError>({ url: '/registry/auxiliaries', ...options });

/**
 * Get an auxiliary model version with its payload, the projects that adopted it and whether its service answers
 */
export const auxiliariesGet = <ThrowOnError extends boolean = false>(options: Options<AuxiliariesGetData, ThrowOnError>): RequestResult<AuxiliariesGetResponses, AuxiliariesGetErrors, ThrowOnError> => (options.client ?? client).get<AuxiliariesGetResponses, AuxiliariesGetErrors, ThrowOnError>({ url: '/registry/auxiliaries/{id}', ...options });

/**
 * The project's triage queue — segments whose pseudo-label members disagreed, newest first
 */
export const triageList = <ThrowOnError extends boolean = false>(options: Options<TriageListData, ThrowOnError>): RequestResult<TriageListResponses, TriageListErrors, ThrowOnError> => (options.client ?? client).get<TriageListResponses, TriageListErrors, ThrowOnError>({ url: '/projects/{p}/triage', ...options });

/**
 * Archive a registry version (soft delete, the admin's); refused while anything uses it
 */
export const versionsArchive = <ThrowOnError extends boolean = false>(options: Options<VersionsArchiveData, ThrowOnError>): RequestResult<VersionsArchiveResponses, VersionsArchiveErrors, ThrowOnError> => (options.client ?? client).post<VersionsArchiveResponses, VersionsArchiveErrors, ThrowOnError>({
    url: '/registry/versions:archive',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List the project's annotation batches, newest first, with progress and agreement
 */
export const batchesList = <ThrowOnError extends boolean = false>(options: Options<BatchesListData, ThrowOnError>): RequestResult<BatchesListResponses, BatchesListErrors, ThrowOnError> => (options.client ?? client).get<BatchesListResponses, BatchesListErrors, ThrowOnError>({ url: '/projects/{p}/batches', ...options });

/**
 * Sample an annotation batch from a dataset version's segments (stratified, the caller's channel by default)
 */
export const batchesNew = <ThrowOnError extends boolean = false>(options: Options<BatchesNewData, ThrowOnError>): RequestResult<BatchesNewResponses, BatchesNewErrors, ThrowOnError> => (options.client ?? client).post<BatchesNewResponses, BatchesNewErrors, ThrowOnError>({
    url: '/projects/{p}/batches',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get an annotation batch — progress, inter-annotator agreement, the adjudication queue, reviewers and whether it can freeze
 */
export const batchesGet = <ThrowOnError extends boolean = false>(options: Options<BatchesGetData, ThrowOnError>): RequestResult<BatchesGetResponses, BatchesGetErrors, ThrowOnError> => (options.client ?? client).get<BatchesGetResponses, BatchesGetErrors, ThrowOnError>({ url: '/batches/{id}', ...options });

/**
 * Freeze a finished batch into a golden set (via goldenSets.freeze) or a training dataset version — an approval
 */
export const batchesFreeze = <ThrowOnError extends boolean = false>(options: Options<BatchesFreezeData, ThrowOnError>): RequestResult<BatchesFreezeResponses, BatchesFreezeErrors, ThrowOnError> => (options.client ?? client).post<BatchesFreezeResponses, BatchesFreezeErrors, ThrowOnError>({ url: '/batches/{id}:freeze', ...options });

/**
 * The items of a batch — the caller's annotation queue (mine), the adjudication queue, or all
 *
 * queue=mine lists what the caller may annotate next (blind: another annotator's text is never shown), then what the caller already annotated; queue=adjudication the disputed items (admin or an adjudicator); queue=all every item (not for reviewers). A reviewer sees only their own annotations.
 *
 */
export const batchItemsList = <ThrowOnError extends boolean = false>(options: Options<BatchItemsListData, ThrowOnError>): RequestResult<BatchItemsListResponses, BatchItemsListErrors, ThrowOnError> => (options.client ?? client).get<BatchItemsListResponses, BatchItemsListErrors, ThrowOnError>({ url: '/batches/{id}/batch-items', ...options });

/**
 * One batch item — its segment, audio window, the bot's script around it, the prefill and the annotations the caller may see
 */
export const batchItemsGet = <ThrowOnError extends boolean = false>(options: Options<BatchItemsGetData, ThrowOnError>): RequestResult<BatchItemsGetResponses, BatchItemsGetErrors, ThrowOnError> => (options.client ?? client).get<BatchItemsGetResponses, BatchItemsGetErrors, ThrowOnError>({ url: '/batches/{id}/batch-items/{item}', ...options });

/**
 * Adjudicate an item — set its final transcript, tags and entity spans, or exclude it (admin or an adjudicator)
 */
export const batchItemsAccept = <ThrowOnError extends boolean = false>(options: Options<BatchItemsAcceptData, ThrowOnError>): RequestResult<BatchItemsAcceptResponses, BatchItemsAcceptErrors, ThrowOnError> => (options.client ?? client).post<BatchItemsAcceptResponses, BatchItemsAcceptErrors, ThrowOnError>({
    url: '/batches/{id}/batch-items/{item}:accept',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Submit the caller's annotation of an item — done, skipped or flagged, with text, tags and entity spans
 *
 * A person's own annotation (agents and API keys are refused). Submitting again replaces the caller's annotation until the item is adjudicated or the batch freezes. The second annotation of a double item comes from another person.
 *
 */
export const annotationsNew = <ThrowOnError extends boolean = false>(options: Options<AnnotationsNewData, ThrowOnError>): RequestResult<AnnotationsNewResponses, AnnotationsNewErrors, ThrowOnError> => (options.client ?? client).post<AnnotationsNewResponses, AnnotationsNewErrors, ThrowOnError>({
    url: '/batches/{id}/batch-items/{item}/annotations',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * The reviewers invited to a batch (admin)
 */
export const invitationsList = <ThrowOnError extends boolean = false>(options: Options<InvitationsListData, ThrowOnError>): RequestResult<InvitationsListResponses, InvitationsListErrors, ThrowOnError> => (options.client ?? client).get<InvitationsListResponses, InvitationsListErrors, ThrowOnError>({ url: '/batches/{id}/invitations', ...options });

/**
 * Invite a reviewer to a batch — a link that opens this batch's items only, play without download (admin)
 *
 * Creates the reviewer (a person with no password) when the name is new, and an invitation link (shown once). The link signs the reviewer in to this batch only: its items and their audio through signed links (no download), nothing else. It expires at expiresAt (at most annotation.invitation_max_days, never after the batch's due date) and when the batch freezes. Revoke it with credentials.revoke.
 *
 */
export const invitationsNew = <ThrowOnError extends boolean = false>(options: Options<InvitationsNewData, ThrowOnError>): RequestResult<InvitationsNewResponses, InvitationsNewErrors, ThrowOnError> => (options.client ?? client).post<InvitationsNewResponses, InvitationsNewErrors, ThrowOnError>({
    url: '/batches/{id}/invitations',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Open a reviewer invitation — sign in to the one batch the link names (no password)
 */
export const authAccept = <ThrowOnError extends boolean = false>(options: Options<AuthAcceptData, ThrowOnError>): RequestResult<AuthAcceptResponses, AuthAcceptErrors, ThrowOnError> => (options.client ?? client).post<AuthAcceptResponses, AuthAcceptErrors, ThrowOnError>({
    url: '/auth:accept',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Resolve a triage item by accepting its best candidate as the segment's human transcript
 */
export const triageAccept = <ThrowOnError extends boolean = false>(options: Options<TriageAcceptData, ThrowOnError>): RequestResult<TriageAcceptResponses, TriageAcceptErrors, ThrowOnError> => (options.client ?? client).post<TriageAcceptResponses, TriageAcceptErrors, ThrowOnError>({
    url: '/triage/{id}:accept',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Resolve a triage item with a person's own transcript of the segment
 */
export const triageCorrect = <ThrowOnError extends boolean = false>(options: Options<TriageCorrectData, ThrowOnError>): RequestResult<TriageCorrectResponses, TriageCorrectErrors, ThrowOnError> => (options.client ?? client).post<TriageCorrectResponses, TriageCorrectErrors, ThrowOnError>({
    url: '/triage/{id}:correct',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Resolve a triage item by dropping the segment (no transcript is written)
 */
export const triageReject = <ThrowOnError extends boolean = false>(options: Options<TriageRejectData, ThrowOnError>): RequestResult<TriageRejectResponses, TriageRejectErrors, ThrowOnError> => (options.client ?? client).post<TriageRejectResponses, TriageRejectErrors, ThrowOnError>({
    url: '/triage/{id}:reject',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Level, voice activity and estimated bandwidth per channel of an utterance's audio, for the audio view's tracks
 *
 * Level in dBFS per hop and channel, speech regions from an energy voice activity detector (the channel's noise floor plus annotation.vad_margin_db), the estimated bandwidth (the highest frequency whose band keeps energy within annotation.bandwidth_floor_db of the loudest band; audio of 8 kHz origin shows ≤ 4 kHz) and, when the audio has a caller and a bot channel, the end-of-utterance gap (the caller's last speech end to the bot's next speech start).
 *
 */
export const tracksGet = <ThrowOnError extends boolean = false>(options: Options<TracksGetData, ThrowOnError>): RequestResult<TracksGetResponses, TracksGetErrors, ThrowOnError> => (options.client ?? client).get<TracksGetResponses, TracksGetErrors, ThrowOnError>({ url: '/registry/utterances/{id}/tracks', ...options });

/**
 * Align the reference texts of several golden sets in one pipeline run (word timings for emission delay)
 */
export const goldenSetsAlign = <ThrowOnError extends boolean = false>(options: Options<GoldenSetsAlignData, ThrowOnError>): RequestResult<GoldenSetsAlignResponses, GoldenSetsAlignErrors, ThrowOnError> => (options.client ?? client).post<GoldenSetsAlignResponses, GoldenSetsAlignErrors, ThrowOnError>({
    url: '/projects/{p}/golden-sets:align',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Export a model version for serving, one deployable per latency profile (GPU spend)
 */
export const modelsExport = <ThrowOnError extends boolean = false>(options: Options<ModelsExportData, ThrowOnError>): RequestResult<ModelsExportResponses, ModelsExportErrors, ThrowOnError> => (options.client ?? client).post<ModelsExportResponses, ModelsExportErrors, ThrowOnError>({
    url: '/projects/{p}/models:export',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Check that an export decodes like the model it came from, through the staging server (R31; GPU spend)
 */
export const modelsParity = <ThrowOnError extends boolean = false>(options: Options<ModelsParityData, ThrowOnError>): RequestResult<ModelsParityResponses, ModelsParityErrors, ThrowOnError> => (options.client ?? client).post<ModelsParityResponses, ModelsParityErrors, ThrowOnError>({
    url: '/projects/{p}/models:parity',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Stream audio through the staging server at real-time pace at each concurrency level and judge the latency budget (R31)
 */
export const modelsBenchmark = <ThrowOnError extends boolean = false>(options: Options<ModelsBenchmarkData, ThrowOnError>): RequestResult<ModelsBenchmarkResponses, ModelsBenchmarkErrors, ThrowOnError> => (options.client ?? client).post<ModelsBenchmarkResponses, ModelsBenchmarkErrors, ThrowOnError>({
    url: '/projects/{p}/models:benchmark',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Deployment targets (staging and delivery) with what they serve, their chain head and the instance signing key
 */
export const deploymentTargetsList = <ThrowOnError extends boolean = false>(options?: Options<DeploymentTargetsListData, ThrowOnError>): RequestResult<DeploymentTargetsListResponses, DeploymentTargetsListErrors, ThrowOnError> => (options?.client ?? client).get<DeploymentTargetsListResponses, DeploymentTargetsListErrors, ThrowOnError>({ url: '/deployment-targets', ...options });

/**
 * Ask for a new deployment target (registry approval for everyone, the admin decides)
 */
export const deploymentTargetsNew = <ThrowOnError extends boolean = false>(options: Options<DeploymentTargetsNewData, ThrowOnError>): RequestResult<DeploymentTargetsNewResponses, DeploymentTargetsNewErrors, ThrowOnError> => (options.client ?? client).post<DeploymentTargetsNewResponses, DeploymentTargetsNewErrors, ThrowOnError>({
    url: '/deployment-targets',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get a deployment target with what it serves and its chain head
 */
export const deploymentTargetsGet = <ThrowOnError extends boolean = false>(options: Options<DeploymentTargetsGetData, ThrowOnError>): RequestResult<DeploymentTargetsGetResponses, DeploymentTargetsGetErrors, ThrowOnError> => (options.client ?? client).get<DeploymentTargetsGetResponses, DeploymentTargetsGetErrors, ThrowOnError>({ url: '/deployment-targets/{id}', ...options });

/**
 * Change a deployment target (registry approval for everyone; a delivery target's chain gets a target-changed record)
 */
export const deploymentTargetsEdit = <ThrowOnError extends boolean = false>(options: Options<DeploymentTargetsEditData, ThrowOnError>): RequestResult<DeploymentTargetsEditResponses, DeploymentTargetsEditErrors, ThrowOnError> => (options.client ?? client).patch<DeploymentTargetsEditResponses, DeploymentTargetsEditErrors, ThrowOnError>({
    url: '/deployment-targets/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Archive a deployment target (soft, the admin's); it takes no new deployments or promotions, its chain stays
 */
export const deploymentTargetsArchive = <ThrowOnError extends boolean = false>(options: Options<DeploymentTargetsArchiveData, ThrowOnError>): RequestResult<DeploymentTargetsArchiveResponses, DeploymentTargetsArchiveErrors, ThrowOnError> => (options.client ?? client).post<DeploymentTargetsArchiveResponses, DeploymentTargetsArchiveErrors, ThrowOnError>({ url: '/deployment-targets/{id}:archive', ...options });

/**
 * A delivery target's promotion record chain, oldest first, every record re-verified on read
 */
export const promotionsList = <ThrowOnError extends boolean = false>(options: Options<PromotionsListData, ThrowOnError>): RequestResult<PromotionsListResponses, PromotionsListErrors, ThrowOnError> => (options.client ?? client).get<PromotionsListResponses, PromotionsListErrors, ThrowOnError>({ url: '/deployment-targets/{id}/promotions', ...options });

/**
 * A promotion record with its signature, key, state, delivery script and (for people) a signed bundle link
 */
export const promotionsGet = <ThrowOnError extends boolean = false>(options: Options<PromotionsGetData, ThrowOnError>): RequestResult<PromotionsGetResponses, PromotionsGetErrors, ThrowOnError> => (options.client ?? client).get<PromotionsGetResponses, PromotionsGetErrors, ThrowOnError>({ url: '/promotions/{id}', ...options });

/**
 * Confirm a delivery with the receipt line deliver.sh printed (people only); appends a signed confirmation record
 */
export const promotionsVerify = <ThrowOnError extends boolean = false>(options: Options<PromotionsVerifyData, ThrowOnError>): RequestResult<PromotionsVerifyResponses, PromotionsVerifyErrors, ThrowOnError> => (options.client ?? client).post<PromotionsVerifyResponses, PromotionsVerifyErrors, ThrowOnError>({
    url: '/promotions/{id}:verify',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Download a promotion's delivery bundle as a gzipped tar (people only; a signed link needs no session)
 *
 * The delivery bundle (cadence.delivery/1) of a promotion record as a .tar.gz: deliver.sh, record.json, record.sig, instance.pub, the model directory, decoding configuration and the smoke set, under one directory named after the record. A request signed by promotions.get (exp, viewer, sig) needs no session and is attributed to its viewer. Every download is written to the audit log. Agents and API keys are refused.
 *
 */
export const deliveryGet = <ThrowOnError extends boolean = false>(options: Options<DeliveryGetData, ThrowOnError>): RequestResult<DeliveryGetResponses, DeliveryGetErrors, ThrowOnError> => (options.client ?? client).get<DeliveryGetResponses, DeliveryGetErrors, ThrowOnError>({ url: '/promotions/{id}/delivery', ...options });

/**
 * The project's deployments, newest first, with stage, shadow progress and pending promotions
 */
export const deploymentsList = <ThrowOnError extends boolean = false>(options: Options<DeploymentsListData, ThrowOnError>): RequestResult<DeploymentsListResponses, DeploymentsListErrors, ThrowOnError> => (options.client ?? client).get<DeploymentsListResponses, DeploymentsListErrors, ThrowOnError>({ url: '/projects/{p}/deployments', ...options });

/**
 * Deploy a model version's export as a shadow on the staging target, replayed nightly from a calls mount
 */
export const deploymentsNew = <ThrowOnError extends boolean = false>(options: Options<DeploymentsNewData, ThrowOnError>): RequestResult<DeploymentsNewResponses, DeploymentsNewErrors, ThrowOnError> => (options.client ?? client).post<DeploymentsNewResponses, DeploymentsNewErrors, ThrowOnError>({
    url: '/projects/{p}/deployments',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * A deployment with its shadow progress, stage history and pending promotion
 */
export const deploymentsGet = <ThrowOnError extends boolean = false>(options: Options<DeploymentsGetData, ThrowOnError>): RequestResult<DeploymentsGetResponses, DeploymentsGetErrors, ThrowOnError> => (options.client ?? client).get<DeploymentsGetResponses, DeploymentsGetErrors, ThrowOnError>({ url: '/deployments/{id}', ...options });

/**
 * Promote a deployment to canary or production on a delivery target's slot (checks, then an approval, then a signed record and its bundle)
 */
export const deploymentsPromote = <ThrowOnError extends boolean = false>(options: Options<DeploymentsPromoteData, ThrowOnError>): RequestResult<DeploymentsPromoteResponses, DeploymentsPromoteErrors, ThrowOnError> => (options.client ?? client).post<DeploymentsPromoteResponses, DeploymentsPromoteErrors, ThrowOnError>({
    url: '/deployments/{id}:promote',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Roll a canary or production deployment back to the slot's earlier production version (approval, signed record, small script)
 */
export const deploymentsRollback = <ThrowOnError extends boolean = false>(options: Options<DeploymentsRollbackData, ThrowOnError>): RequestResult<DeploymentsRollbackResponses, DeploymentsRollbackErrors, ThrowOnError> => (options.client ?? client).post<DeploymentsRollbackResponses, DeploymentsRollbackErrors, ThrowOnError>({
    url: '/deployments/{id}:rollback',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * A shadow deployment's nightly replays, newest first, with the divergence of each night
 */
export const shadowReplaysList = <ThrowOnError extends boolean = false>(options: Options<ShadowReplaysListData, ThrowOnError>): RequestResult<ShadowReplaysListResponses, ShadowReplaysListErrors, ThrowOnError> => (options.client ?? client).get<ShadowReplaysListResponses, ShadowReplaysListErrors, ThrowOnError>({ url: '/deployments/{id}/shadow-replays', ...options });

/**
 * Replay the newest unreplayed calls of a shadow deployment now, instead of waiting for the night (GPU spend)
 */
export const shadowReplaysNew = <ThrowOnError extends boolean = false>(options: Options<ShadowReplaysNewData, ThrowOnError>): RequestResult<ShadowReplaysNewResponses, ShadowReplaysNewErrors, ThrowOnError> => (options.client ?? client).post<ShadowReplaysNewResponses, ShadowReplaysNewErrors, ThrowOnError>({ url: '/deployments/{id}/shadow-replays', ...options });

/**
 * One night's shadow replay with its most divergent segments (texts kept deploy.shadow_artifact_retention_days)
 */
export const shadowReplaysGet = <ThrowOnError extends boolean = false>(options: Options<ShadowReplaysGetData, ThrowOnError>): RequestResult<ShadowReplaysGetResponses, ShadowReplaysGetErrors, ThrowOnError> => (options.client ?? client).get<ShadowReplaysGetResponses, ShadowReplaysGetErrors, ThrowOnError>({ url: '/shadow-replays/{id}', ...options });
